import { k, b, G, a, l, F, y, fa, da as da$1, ha as ha$1, n as n$1, w, p, q, o, x, E as E$1, e, h, f as f$1, ea as ea$1, $, aa, ca as ca$1, j, R, O, r, M, Z, s, u as u$1, i, A, K, z } from './chunk-KUEGDP2C.js';
import { c } from './chunk-J2JGPZHY.js';
import { n, a as a$1, u, s as s$1, D, B, o as o$1, t, b as b$1, g, p as p$1 } from './chunk-6O5I75HI.js';
import { f as f$2, e as e$1 } from './chunk-EU5NKIY3.js';
import { f, j as j$1, e as e$2, h as h$1, d, g as g$1 } from './chunk-UTFXT4BW.js';
import Ee, { css, keyframes, createGlobalStyle, useTheme, ThemeProvider } from 'styled-components';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { rgba, parseToRgb } from 'polished';
import * as ee from 'react';
import ee__default, { forwardRef, memo, useMemo, useRef, useState, useCallback, useImperativeHandle, useEffect, createElement, useLayoutEffect } from 'react';
import { animated, useSpring, useTransition } from 'react-spring';
import { defineMessages, useLocales, commonMessages, LocaleRoot, gflMessages } from '@sevenrooms/locales';
import be from 'lodash';
import { Breadcrumbs } from '@sevenrooms/react-components/components/Breadcrumbs';
import { useThrottledCallback } from 'use-debounce';
import po from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { Carousel, useCarousel } from 'nuka-carousel';
import { ExperienceBySevenRooms } from '@sevenrooms/react-components/components/ExperienceBySevenRooms';
import { Link, useNavigation, useSurfaceScope, useLocation, matchPath } from '@sevenrooms/navigation';
import Nl from 'react-focus-lock';
import Zn from 'react-merge-refs';
import { TouchScrollable } from 'react-scrolllock';
import { ToastContainer, cssTransition, toast, Slide, Bounce, Zoom, Flip } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import kd from 'css-time';
import Md from 'react-keyboard-event-handler';
import { Transition } from 'react-transition-group';
import { useCombobox } from 'downshift';
import cc from 'use-resize-observer';
import { useFormState } from '@sevenrooms/form';
import Lo from 'moment/moment';
import { DayPickerSingleDateController } from 'react-dates';
import 'react-dates/initialize';
import '@fontsource/roboto';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { Normalize } from 'styled-normalize';
import { ThemeProvider as ThemeProvider$1, vmsTheme, gxTheme } from '@sevenrooms/react-components/components/ThemeProvider';
import * as Di from 'react-dom';
import Up from 'constate';
import { useTable, useSortBy, useExpanded, usePagination, useRowSelect } from 'react-table';
import * as he from 'react-tabs';
import { parsePhoneNumber } from 'react-phone-number-input';
import { readIFrameMessage } from '@sevenrooms/connect-iframe';
import { SevenRoomsIcon } from '@sevenrooms/react-components/components/SevenRoomsIcon';
import { SevenRoomsProgress } from '@sevenrooms/react-components/components/SevenRoomsProgress';
import { Avatar } from '@sevenrooms/react-components/components/Avatar';
import { IconButton } from '@sevenrooms/react-components/components/IconButton';

function Ar({firstName:e,lastName:t,size:o,fontSize:r,image:n,textStyle:i}){let a=e?.charAt(0)??"",s=t?.charAt(0)??"",m=a+s,d=o||"24px";return jsx(Na,{width:d,height:d,image:n,fontSize:r,textStyle:i,children:n?null:m})}var Na=Ee(k)`
  align-items: center;
  background-color: ${e=>e.theme.colors.mutedBackground};
  border-radius: 50%;
  color: ${e=>e.theme.colors.mutedFont};
  ${e=>e.textStyle&&`font: ${e.theme.textStyles[e.textStyle]};`}
  font-size: ${e=>e.fontSize?e.theme.fontSizes[e.fontSize]:e.theme.fontSizes.s};
  justify-content: center;
  text-transform: uppercase;
  ${e=>e.image&&css`
      background-size: cover;
      background-image: url(${e.image});
    `}
`;function Gr(e){let t=useTheme(),o=ee.useMemo(()=>({visible:rgba({...parseToRgb(t.colors.backdrop),alpha:.3}),invisible:rgba({...parseToRgb(t.colors.backdrop),alpha:0})}),[t.colors.backdrop]),r=useSpring({backgroundColor:e.isActive?o.visible:o.invisible,pointerEvents:e.isActive?"all":"none",config:{duration:150}});return jsx(Va,{...e,style:r,"data-test":"ui-kit-backdrop",children:e.children})}var Va=Ee(animated.div).withConfig({shouldForwardProp:e=>e!=="isActive"})`
  will-change: background-color, pointer-events;
  position: fixed;
  z-index: ${e=>e.theme.zIndex.modal};
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;function Ph({title:e$2,description:t,to:o,isExternal:r,icon:n,...i}){let a$1=jsxs(Ua,{borderRadius:"s",borderColor:"dividerLines",borderWidth:"s",backgroundColor:"primaryBackground",alignItems:"center",justifyContent:"center",flexWrap:"wrap",...i,children:[n&&jsx(Xa,{pr:"m",flexDirection:"column",flex:"0 0",children:n}),jsxs(k,{pr:"m",flexDirection:"column",flex:"10 1 250px",children:[jsx(a,{children:jsx(e,{fontWeight:"bold",children:e$2})}),t&&jsx(j,{fontSize:"s",children:t})]}),o&&jsx(Ka,{pl:"m",flexDirection:"column",flex:"0 0",children:jsx(e$1,{name:"VMSWeb-chevron-right",size:"lg"})})]});return o?jsx(R,{to:o,isExternal:r,"data-test":"action-link",children:a$1}):a$1}var Ua=Ee(k)`
  ${e=>"p"in e?css`
          padding: ${b(e,e.p)};
        `:css`
          padding-top: ${b(e,e.pt)};
          padding-right: ${b(e,e.pr)};
          padding-bottom: ${b(e,e.pb)};
          padding-left: ${b(e,e.pl)};
        `}
`,Xa=Ee(k)`
  ${e=>css`
      & > i {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 1.2em;
        height: 1.2em;
        border-radius: 50%;
        background-color: ${e.theme.colors.highlight};
        border: 1px solid ${e.theme.colors.brandColor};
        padding: 2px;
    `}
`,Ka=Ee(k)`
  ${e=>css`
      & > i {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 1.2em;
        height: 1.2em;
        border-radius: 50%;
        background-color: ${e.theme.colors.iconHover};
    `}
`;var Xr='data:image/svg+xml,<svg height="60" width="60" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor"%0A  viewBox="0 0 3947 3947">%0A  <defs>%0A    <clipPath id="a">%0A      <circle cx="1973.5" cy="1973.5" r="1380" />%0A    </clipPath>%0A  </defs>%0A  <path stroke-dasharray="1706" stroke-width="150" d="M2590.15 1018.5H883.997" clip-path="url(%23a)">%0A    <animate attributeName="stroke-dashoffset" begin="0s" dur="2s" keyTimes="0; 0.12; 0.32; 0.61; 0.70; 1"%0A      repeatCount="indefinite" values="5118; 5118; 3412; 3412; 1706; 1706;" />%0A  </path>%0A  <path stroke-dasharray="2232.73" stroke-width="150" d="M2279 1100 730.001 2708" clip-path="url(%23a)">%0A    <animate attributeName="stroke-dashoffset" begin="0s" dur="2s" keyTimes="0;0.16;0.4;0.65;0.74;1"%0A      repeatCount="indefinite" values="6698.19;6698.19;4465.46;4465.46;2232.73;2232.73;" />%0A  </path>%0A  <path stroke-dasharray="1822" stroke-width="150" d="M1961 1600v1822" clip-path="url(%23a)">%0A    <animate attributeName="stroke-dashoffset" begin="0s" dur="2s" keyTimes="0;0.23;0.4;0.72;0.81;1"%0A      repeatCount="indefinite" values="5466;5466;3644;3644;1822;1822;" />%0A  </path>%0A  <path stroke-dasharray="1330.8" stroke-width="150" d="m2029 2082 936 946" clip-path="url(%23a)">%0A    <animate attributeName="stroke-dashoffset" begin="0s" dur="2s" keyTimes="0;0.28;0.4;0.77;0.86;1"%0A      repeatCount="indefinite" values="3992.4;3992.4;2661.6;2661.6;1330.8;1330.8;" />%0A  </path>%0A  <circle cx="1973.5" cy="1973.5" r="1452.5" stroke-dasharray="9126.33" stroke-width="150"%0A    transform="rotate(-21 1973.5 1973.5)">%0A    <animate attributeName="stroke-dashoffset" begin="0s" dur="2s" keyTimes="0;0.45;0.50;1" repeatCount="indefinite"%0A      values="0;9126.33;9126.33;18252.66;" />%0A  </circle>%0A  <circle cx="1973.5" cy="1973.5" r="1452.5" stroke-dasharray="20 9126.33" stroke-width="148" color="%23000"%0A    transform="rotate(-21.5 1973.5 1973.5)" />%0A  <circle cx="2674.5" cy="1719.5" r="705.5" stroke-dasharray="4432.79" stroke-width="150"%0A    transform="rotate(-22.28 2674.5 1719.5)">%0A    <animate attributeName="stroke-dashoffset" begin="0s" dur="2s" keyTimes="0;0.45;0.50;1" repeatCount="indefinite"%0A      values="4432.79;8865.58;8865.58;13298.37;" />%0A  </circle>%0A</svg>';var Za={xs:"24px",s:"32px",m:"48px"};function Kr({size:e="s"}){return jsx("img",{src:Xr,width:Za[e],alt:"..."})}var Ja={top:"column",bottom:"column-reverse",left:"row",right:"row-reverse"};function Yr({icon:e$1,align:t="bottom",size:o="s",children:r,...n}){return jsxs(k,{flexDirection:Ja[t],alignItems:"center",...n,children:[jsx(a,{p:"s",children:e$1||jsx(Kr,{size:o})}),!be.isNil(r)&&jsx(a,{p:"s",children:jsx(e,{children:r})})]})}var Zr=defineMessages({dismiss:{id:"uikit.banner.dismiss",defaultMessage:"Dismiss"}});function qr({type:e$1="warning",icon:t,title:o,action:r,onAction:n,canDismiss:i=true,onDismiss:a$1,description:s,isActionDisabled:m,isLoading:d,...p}){let{formatMessage:f}=useLocales(),c="attention";return jsx(os,{type:e$1,pt:"m",pb:"m",pr:"lm",pl:"lm",alignItems:"center",justifyContent:"center",flexWrap:"wrap",...p,children:d?jsx(Yr,{}):jsxs(Fragment,{children:[t&&jsx(ns,{pr:"m",flexDirection:"column",flex:"0 0",isAttention:e$1===c,children:t}),jsxs(k,{pr:"m",flexDirection:"column",flex:"10 1 250px",children:[o&&jsx(a,{pb:s?"xs":undefined,children:jsx(e,{fontWeight:"bold",children:o})}),s&&jsx(j,{children:s})]}),(n&&r||i&&a$1)&&jsxs(k,{justifyContent:e$1===c?"flex-end":"space-between",flex:"1 1 0",children:[n&&r&&jsx(rs,{"data-test":"sr-banner-action-button",variant:e$1===c?"primary":"secondary",size:"s",onClick:n,disabled:m,isAttention:e$1===c,children:r}),a$1&&i&&jsx(G,{"data-test":"sr-banner-dismiss-button",variant:"tertiary",icon:"VMSWeb-close",onClick:a$1,children:f(Zr.dismiss)})]})]})})}var os=Ee(k)`
  ${e=>e.type!=="attention"&&css`
      border: 2px solid ${e.theme.colors[e.type]};
    `}
  border-radius: 4px;
  background-color: ${e=>e.type==="attention"?e.theme.colors.highlight:e.theme.colors[`${e.type}Background`]};
`,rs=Ee(G)`
  background-color: ${e=>e.isAttention?`${e.theme.colors.primaryButton} !important`:e.theme.colors.inputBackground};

  ${e=>e.isAttention&&css`
      padding: 0 1em !important;
    `}
`,ns=Ee(k)`
  ${e=>e.isAttention&&css`
      & > i {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 2em;
        height: 2em;
        border-radius: 50%;
        background-color: white;
        color: ${e.theme.colors.primaryButton};
    `}
`;function tu({banners:e,setBanners:t}){let o=n=>t(e.filter(i=>i.key!==n)),r=n=>{n.onDismiss?.(),o(n.key);};return jsx(Fragment,{children:e.map((n,i)=>jsx(a,{pb:i+1!==e.length?"m":undefined,children:jsx(qr,{...n,onDismiss:()=>r(n)})},n.key))})}var fu=Ee(a)`
  border: 1px solid ${f.colors.dividerLines};
  border-radius: 4px;
  box-sizing: border-box;
  height: ${e=>e.height};
`;var Qr=defineMessages({breadcrumbs:{id:"uikit.breadcrumbs.breadcrumbs",defaultMessage:"breadcrumbs"}});function wu(e){let{formatMessage:t}=useLocales();return jsx(ps,{children:jsx(Breadcrumbs,{"aria-label":e.ariaLabel??t(Qr.breadcrumbs),separator:e.separator?e.separator:jsx(a,{pt:"xxs",children:jsx(e$1,{name:"VMSWeb-chevron-right"})}),...e})})}var ps=Ee.div`
  .MuiBreadcrumbs-li {
    appearance: auto;
  }

  .MuiBreadcrumbs-separator {
    margin-left: ${e=>e.theme.spacing.xs};
    margin-right: ${e=>e.theme.spacing.xs};
  }
`;function Jr({children:e,variant:t="primary",flexDirection:o="column",backgroundColor:r,borderColor:n,...i}){return jsx(hs,{variant:t,position:"relative",width:"100%",backgroundColor:r||t==="secondary"&&"secondaryBackground",borderColor:n||t==="primary"&&"borders",flexDirection:o,borderRadius:"s",...i,children:e})}var hs=Ee(l)`
  overflow: hidden;

  ${e=>e.hoverable&&css`
      cursor: pointer;
      &:hover {
        background-color: ${t=>t.theme.colors.inputHoverBackground};
      }
      ${F} {
        background-color: transparent;
      }
    `}
`;function jr({as:e,...t}){return jsx(ys,{...t})}var ys=Ee(a)`
  ${e=>e.onClick&&css`
      cursor: pointer;
    `}
`;function me(e){return jsx(vs,{...e})}var vs=Ee.div`
  ${e=>e.collapsed&&css`
      height: 0px;
      overflow: hidden;
    `}
`;function nn({hideLast:e=false,content:t,...o}){return jsxs(ws,{"align-items":"center",hideLast:e,children:[jsx(en,{...o}),t&&jsxs(Fragment,{children:[t,jsx(en,{...o})]})]})}var en=Ee.hr`
  border: none;
  height: 1px;
  color: ${e=>e.color?e.theme.colors[e.color]:e.theme.colors.dividerLines};
  background-color: ${e=>e.color?e.theme.colors[e.color]:e.theme.colors.dividerLines};
  margin: ${e=>e.theme.spacing[e.margin??"s"]};
  ${e=>e.ml&&`margin-left: ${e.theme.spacing[e.ml]};`}
  ${e=>e.mr&&`margin-right: ${e.theme.spacing[e.mr]};`}
  ${e=>e.mt&&`margin-top: ${e.theme.spacing[e.mt]};`}
  ${e=>e.mb&&`margin-bottom: ${e.theme.spacing[e.mb]};`}
  width: 100%;
`,ws=Ee(k)`
  &:last-child {
    ${e=>e.hideLast&&"display: none;"}
  }
`;function rx({template:e,variablesFromTemplate:t,variables:o,venueName:r,height:n,scale:i}){let[a,s]=useState(()=>an({template:e,variablesFromTemplate:t,variables:o})),m=useThrottledCallback(()=>{let d=an({template:e,variablesFromTemplate:t,variables:o});i!=null&&(d=d.replace("<head>",`<head>
          <style>
            body {
              display: flex;
              justify-content: center;
              margin: 0;
              transform: scale(${i});
              transform-origin: 50% 0;
            }
          </style>
        `)),!o.venue_logo&&r&&(d=d.replace(/<[^>]*{{venue_logo}}[^>]*>/gi,r)),s(d);},500);return useEffect(()=>{m.callback();},[o,e,m]),jsx(Ms,{srcDoc:a,height:n,"data-test":"sr-email-preview-iframe"})}var an=({template:e,variablesFromTemplate:t,variables:o})=>t.reduce((r,n)=>{let i=o[n];return i?r.replace(new RegExp(`{{${n}}}`,"ig"),String(i)):r},e),Ms=Ee.iframe`
  flex-grow: 1;
  border: none;
  border-radius: 4px;
  height: ${e=>e.height??e.theme.imageUploader.height};
`;var sn='data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 72 73">%0A  <g clip-path="url(%23a)">%0A    <path fill="%231D1D1D"%0A      d="M36 0C16.1173 0 0 16.3411 0 36.5S16.1173 73 36 73s36-16.3411 36-36.5S55.8827 0 36 0Zm31.6442 30.7053c0 8.3792-6.6991 15.1713-14.9635 15.1713-8.2643 0-14.9634-6.7921-14.9634-15.1713 0-8.3791 6.6991-15.1713 14.9634-15.1713 8.2644 0 14.9635 6.7922 14.9635 15.1713ZM36 3.4754c9.0358 0 17.2129 3.7316 23.1138 9.7553-2.0035-.7595-4.1724-1.1744-6.4353-1.1744H14.0959C19.8805 6.7242 27.5657 3.4732 36 3.4732v.0022Zm-1.715 27.2299V69.477c-10.8872-.5714-20.359-6.5655-25.844-15.3663l26.0877-26.45a18.9792 18.9792 0 0 0-.2437 3.0446ZM6.7058 50.9549c-2.0996-4.3664-3.278-9.2701-3.278-14.4549 0-7.9597 2.7772-15.262 7.4035-20.966h31.1478a18.4893 18.4893 0 0 0-2.6787 2.3714L6.7058 50.9549ZM37.715 69.4792V41.5511a18.7569 18.7569 0 0 0 2.5849 2.9472l16.8685 17.1028c-5.2882 4.5886-12.0432 7.4882-19.4534 7.8781Zm21.9377-10.2744-9.957-10.0953c.9704.161 1.9654.2448 2.9806.2448 6.6164 0 12.4166-3.5434 15.6566-8.8597-.8564 7.2093-4.0047 13.7022-8.6825 18.7102h.0023Z" />%0A  </g>%0A  <defs>%0A    <clipPath id="a">%0A      <path fill="%23fff" d="M0 0h72v73H0z" />%0A    </clipPath>%0A  </defs>%0A</svg>';function je(e){let t=useRef(null);return useEffect(()=>{t.current&&e.fetchPriority&&(t.current.fetchPriority=e.fetchPriority);},[e.fetchPriority]),jsx(Hs,{ref:t,...e})}var Hs=Ee.img`
  ${e=>e.centered&&css`
      object-fit: cover;
      object-position: center;
    `}
  ${e=>e.borderRadius&&css`
      border-radius: ${e.theme.borderRadius[e.borderRadius]};
    `}
  ${e=>e.maxWidth&&css`
      max-width: ${e.maxWidth};
    `}
  ${e=>e.objectFit&&css`
      object-fit: ${e.objectFit};
    `}
`,dn=Ee(je)`
  max-width: ${e=>e.maxWidth??"100%"};
  max-height: ${e=>e.maxHeight??"100%"};

  ${e=>e.height!==undefined&&css`
      min-height: ${e.height};
    `}
`;function cn({imageUrl:e,fallback:t,onImageLoadFailure:o,...r}){let[n,i]=useState(!!e);return n?jsx(je,{src:e??"",onError:()=>{o?.(),i(false);},...r}):t}function so({cropData:e,onError:t,src:o,width:r,height:n,...i}){let a=useRef(null),s=typeof r=="string"?parseFloat(r):r,m=typeof n=="string"?parseFloat(n):n,d=useRef(new Image(s,m));return d.current.onload=()=>{let p=a.current,f=p?.getContext("2d");if(!p||!f){t?.();return}let{x:c,y:h,width:g,height:S}=Vs(e),b=c/100*d.current.naturalWidth,y=h/100*d.current.naturalHeight,P=g/100*d.current.naturalWidth,C=S/100*d.current.naturalHeight;p.width=s||P,p.height=m||C,f.drawImage(d.current,b,y,P,C,0,0,p.width,p.height);},d.current.onerror=t??null,d.current.src=o,jsx(Gs,{ref:a,role:"img",canvasHeight:n,canvasWidth:r,...i})}var _s=e=>Object.values(e).every(t=>t>0),Vs=e=>_s(e)?{...e,width:e.x+e.width>100?100-e.x:e.width,height:e.y+e.height>100?100-e.y:e.height}:{x:0,y:0,width:100,height:100},Gs=Ee.canvas`
  ${e=>css`
    width: ${e.canvasWidth};
    height: ${e.canvasHeight};
  `}
`;function pn(){switch(window.location.hostname){case "www.sevenrooms.com":case "eu.sevenrooms.com":return  true;default:return  false}}var Xs="Whoops! Something went wrong. Please wait a few moments and then try again.";function Ex({error:e$1}){let t=pn();return jsxs(n$1,{height:"100vh",width:"100vw",children:[jsx(a,{width:"100%",textAlign:"center",p:"3xl 3xl m 3xl",children:jsx(je,{width:"120px",height:"120px",src:sn,alt:"SevenRooms Logo"})}),jsxs(n$1,{width:"100%",flexGrow:1,alignItems:"center",spacing:"m",pt:"m",children:[jsx(e,{fontSize:"l",fontWeight:"bold",color:"darkFont",children:"Looks like this page is off the menu."}),jsx(e,{color:"darkFont",children:t||!e$1?.toString()?Xs:e$1?.toString()}),jsx(G,{"data-test":"sr-error-page-go-back",variant:"primary",href:"/",isExternal:true,children:jsx(e,{color:"lightFont",children:"Go Back"})})]})]})}function Ks(e,t){return jsx(l,{...e,ref:t,flexDirection:"row"})}var v=ee.forwardRef(Ks);function Xx({includeNavWidth:e=false,children:t,...o}){return jsx(qs,{alignItems:"center",height:"56px",width:"100%",pl:"lm",pt:"sm",pr:"lm",pb:"sm",spacing:"l",includeNavWidth:e,...o,children:t})}var qs=Ee(v)`
  position: fixed;
  width: ${e=>e.includeNavWidth?`calc(100% - ${e.theme.sizes.sideNavWidth} - ${e.theme.sizes.tabsNavWidth})`:"100%"};
  bottom: 0;
  background-color: ${e=>e.theme.colors.primaryBackground};
  border: 1px solid ${e=>e.theme.colors.margin};
  box-sizing: border-box;
  box-shadow: ${e=>e.theme.shadows.primaryUp};
  border-radius: 8px 8px 0 0;
`;var hn=defineMessages({footerTotalItemSeparator:{id:"footer.item.total.separator",defaultMessage:"of {amount}"}});function ob({primary:e$1,secondary:t,label:o,info:r}){let{formatMessage:n}=useLocales(),i=t!==undefined;return jsxs(v,{spacing:"sm",alignItems:"center",children:[jsxs(v,{alignItems:"center",spacing:"xs",children:[jsx(e,{lineHeight:"s",fontSize:"xl",color:"primarySelected",children:i?t:e$1}),i&&jsx(e,{color:"primarySelected",children:n(hn.footerTotalItemSeparator,{amount:e$1})})]}),jsxs(v,{spacing:"s",children:[jsx(j,{fontSize:"s",children:o}),r&&jsx(O,{tooltip:{content:r},"data-test":"sr-additional-information"})]})]})}function ol(e,t){return jsx(rl,{...e,display:"grid",ref:t})}var kt=forwardRef(ol),rl=Ee(a)`
  grid-template-columns: ${e=>e.gridTemplateColumns};
  grid-template-rows: ${e=>e.gridTemplateRows};
  grid-template-areas: ${e=>e.gridTemplateAreas};
  grid-template: ${e=>e.gridTemplate};
  grid-auto-columns: ${e=>e.gridAutoColumns};
  grid-auto-rows: ${e=>e.gridAutoRows};
  grid-auto-flow: ${e=>e.gridAutoFlow};
  grid: ${e=>e.grid};
  grid-row-start: ${e=>e.gridRowStart};
  grid-column-start: ${e=>e.gridColumnStart};
  grid-row-end: ${e=>e.gridRowEnd};
  grid-column-end: ${e=>e.gridColumnEnd};
  grid-row: ${e=>e.gridRow};
  grid-column: ${e=>e.gridColumn};
  grid-area: ${e=>e.gridArea};
  align-items: ${e=>e.alignItems};
  justify-items: ${e=>e.justifyItems};

  ${e=>!be.isNil(e.gap)&&css`
      gap: ${b(e,e.gap)};
    `}

  ${e=>!be.isNil(e.rowGap)&&css`
      row-gap: ${b(e,e.rowGap)};
    `}


    ${e=>!be.isNil(e.columnGap)&&css`
      column-gap: ${b(e,e.columnGap)};
    `}
`;var We="#eee",un=Ee(k)`
  background-image: linear-gradient(45deg, ${We} 25%, transparent 25%, transparent 75%, ${We} 75%, ${We}),
    linear-gradient(45deg, ${We} 25%, transparent 25%, transparent 75%, ${We} 75%, ${We});
  background-size: 20px 20px;
  background-position: 0 0, 10px 10px;
`;var ll="default"in po?po.default:po;function $b({url:e,image:t,crop:o,onError:r,options:n,unit:i="px"}){let a=useMemo(()=>{if(o.rect&&t.dimension&&i==="%")return {...o.rect,unit:i};if(o.rect&&t.dimension)return {x:o.rect.x/t.dimension.scaleX,width:o.rect.width/t.dimension.scaleX,y:o.rect.y/t.dimension.scaleY,height:o.rect.height/t.dimension.scaleY,unit:i}},[o,t.dimension,i]),s=useCallback((d,p)=>{t.dimension&&i==="%"?o.setRect(p):t.dimension&&o.setRect({x:d.x*t.dimension.scaleX,width:d.width*t.dimension.scaleX,y:d.y*t.dimension.scaleY,height:d.height*t.dimension.scaleY,unit:i});},[o,t.dimension,i]),m=useMemo(()=>{let d="unset";return !t.element&&t.naturalSize&&(d=`${100*(t.naturalSize.height/t.naturalSize.width)}%`),d},[t]);return useEffect(()=>()=>t.setElement(undefined),[e]),jsx(dl,{children:e&&jsx(cl,{maxWidth:t.naturalSize&&`${t.naturalSize.width}px`||"unset",onDoubleClick:o.selectAll,children:jsx(ml,{spacePlaceholder:m,"data-test":"sr-logo-editor-crop-section",children:jsx(ll,{...n,crop:a,onChange:s,keepSelection:true,children:jsx("img",{src:e,alt:"being croped",onLoad:d=>t.setElement(d.currentTarget),onError:r})})})})})}var dl=Ee(un)`
  width: 100%;
  align-items: center;
  justify-content: center;
`,cl=Ee.div`
  max-width: ${e=>e.maxWidth};
`,I=11,E=5,ml=Ee.div`
  margin: auto;
  display: flex;
  width: 100%;
  max-width: ${e=>e.spacePlaceholder};

  .ReactCrop {
    max-height: initial;
  }

  .ReactCrop__crop-selection {
    border: none;
  }

  .ReactCrop__drag-handle {
    margin: 0 !important;
  }
  .ReactCrop__drag-handle::after,
  .ReactCrop__drag-handle::before {
    border: none;
    outline: none;
    background-color: ${e=>e.theme.colors.primaryButton};
  }

  .ReactCrop__drag-handle::before {
    content: '';
    display: block;
    position: absolute;
    box-sizing: border-box;
  }

  .ReactCrop__drag-handle.ord-nw:after {
    width: ${I}px;
    height: ${E}px;
  }

  .ReactCrop__drag-handle.ord-nw:before {
    width: ${E}px;
    height: ${I}px;
  }

  .ReactCrop__drag-handle.ord-n:after {
    width: ${I}px;
    height: ${E}px;
    margin-left: -${I/2}px;
  }

  .ReactCrop__drag-handle.ord-ne:after {
    width: ${I}px;
    height: ${E}px;
    margin-left: -${I}px;
  }

  .ReactCrop__drag-handle.ord-ne:before {
    width: ${E}px;
    height: ${I}px;
    margin-left: -${E}px;
  }

  .ReactCrop__drag-handle.ord-w:after {
    width: ${E}px;
    height: ${I}px;
    margin-top: -${I/2}px;
  }

  .ReactCrop__drag-handle.ord-e:after {
    width: ${E}px;
    height: ${I}px;
    margin-left: -${E}px;
    margin-top: -${I/2}px;
  }

  .ReactCrop__drag-handle.ord-sw:after {
    width: ${I}px;
    height: ${E}px;
    margin-top: -${I}px;
  }

  .ReactCrop__drag-handle.ord-sw:before {
    width: ${E}px;
    height: ${I}px;
    margin-top: -${I}px;
  }

  .ReactCrop__drag-handle.ord-s:after {
    width: ${I}px;
    height: ${E}px;
    margin-left: -${I/2}px;
    margin-top: -${E}px;
  }

  .ReactCrop__drag-handle.ord-se:after {
    width: ${I}px;
    height: ${E}px;
    margin-left: -${I/2}px;
    margin-top: -${E}px;
  }

  .ReactCrop__drag-handle.ord-se:before {
    width: ${E}px;
    height: ${I}px;
    margin-left: -${E}px;
    margin-top: -${I}px;
  }

  @media (pointer: coarse) {
    .ReactCrop__drag-handle {
      width: inherit;
      height: inherit;
    }
  }
`;var bn="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=",Mb=(e,t,o)=>!e||!t||!o?bn:pl(e,o)??bn,pl=(e,t)=>{let o=document.createElement("canvas"),r=o.getContext("2d"),n=t.unit==="%"?t.x*e.naturalWidth/100:t.x,i=t.unit==="%"?t.y*e.naturalHeight/100:t.y,a=t.unit==="%"?t.width*e.naturalWidth/100:t.width,s=t.unit==="%"?t.height*e.naturalHeight/100:t.height;return o.width=a,o.height=s,r?.drawImage(e,n,i,a,s,0,0,a,s),o.toDataURL("image/png")};var fl=30;function Eb({minHeight:e=fl,maxHeight:t,maxWidth:o,currentHeight:r},n={width:1,height:1,x:1,y:1}){let i=ee__default.useMemo(()=>n.width/n.height,[n]),a=ee__default.useCallback(p=>{let f=i*p;return f>o?f/n.width*n.height:p},[n,i,o]),[s,m]=ee__default.useMemo(()=>{let p=Math.min(n.height,r),f=p,c=i*p;return c>o&&(c=o,f=c/n.width*n.height),[c,f]},[n,r,o]),d=ee__default.useMemo(()=>({min:a(e),max:a(t),calculatedWidth:s,calculatedHeight:m}),[a,e,t,s,m]);return ee__default.useMemo(()=>({byHeight:d}),[d])}function Nb(e,t,o,r="px"){let[n,i]=useState(t),a=useRef(e.element),s=useMemo(()=>n?!n.height&&!n.width:true,[n]),m=useCallback(()=>{if(e.naturalSize){let{width:d,height:p}=e.naturalSize,f={x:0,y:0,unit:n?.unit??r};if(!o){i({...f,width:f.unit==="%"?100:d,height:f.unit==="%"?100:p});return}let c=d/p;f.unit==="%"?i({...f,width:c<o?100:100*o/c,height:c<o?100*c/o:100}):i({...f,width:c<o?d:p*o,height:c<o?d/o:p});}},[e.naturalSize,n?.unit,r,o]);return useEffect(()=>{a.current&&a.current!==e.element&&i(undefined),a.current=e.element;},[e.element]),useEffect(()=>{s&&m();},[s,m]),{rect:n,setRect:i,selectAll:m}}function Ab(e){let[t,o]=useState(undefined),[r,n]=useState(e),i=useMemo(()=>t?{width:t.naturalWidth,height:t.naturalHeight}:r,[r,t]);useEffect(()=>()=>n(undefined),[t]);let a=useMemo(()=>t?{width:t.width,height:t.height,scaleX:t.naturalWidth/t.width,scaleY:t.naturalHeight/t.height}:undefined,[t]);return {element:t,setElement:o,dimension:a,naturalSize:i}}function ry({images:e,imagesWithFallback:t,height:o}){return jsx(n$1,{alignItems:"center",justifyContent:"center",width:"100%",height:"100%",borderRadius:"s",overflow:"hidden","data-test":"room-images",children:jsxs(kl,{showDots:true,dots:jsx(Cl,{}),showArrows:true,arrows:jsx(Pl,{}),children:[e&&e.map(r=>jsx(vl,{src:r,maxHeight:o,width:"100%",alt:"image"},r)),t&&t.map(({src:r,fallback:n,crop:i,alt:a})=>jsx(Tl,{imageUrl:r,alt:a||"",maxHeight:o,fallback:jsx(wl,{src:n,cropData:i,maxHeight:o,"aria-label":a||""},r)},r))]})})}function Cl(){let{totalPages:e,currentPage:t,goToPage:o}=useCarousel();return jsx(v,{spacing:"s",mt:"sm",children:[...Array(e)].map((r,n)=>jsx(Rl,{onClick:()=>o(n),isActive:n===t,"data-test":`${n+1}-dot`},`${n}-dot`))})}function Pl(){let{currentPage:e,totalPages:t,goBack:o,goForward:r}=useCarousel(),n=e>0,i=e<t-1;return jsxs("div",{children:[jsx(Pn,{p:"none m",visibility:n?"initial":"hidden",children:jsx(x,{icon:"VMSWeb-chevron-left",iconBackgroundColor:"primaryBackground","data-test":"chevron-left",onClick:o})}),jsx(Pn,{p:"none m",isRight:true,visibility:i?"initial":"hidden",children:jsx(x,{icon:"VMSWeb-chevron-right",iconBackgroundColor:"primaryBackground","data-test":"chevron-right",onClick:r})})]})}var go=({maxHeight:e})=>css`
  object-fit: cover;
  object-position: center center;
  min-width: 100%;
  max-height: ${e||"100%"};
`,vl=Ee.img`
  ${e=>go(e)}
`,Tl=Ee(cn)`
  ${e=>go(e)}
`,wl=Ee(so)`
  ${e=>go(e)}
`,kl=Ee(Carousel)`
  width: 100%;
`,Rl=Ee(G)`
  padding: 0;
  width: 8px;
  height: 8px;
  background-color: ${e=>e.isActive?e.theme.colors.brandColor:e.theme.colors.primaryBackground};
  border: ${e=>`${e.theme.borderWidth.s} solid ${e.theme.colors.secondaryFont}`};
`,Pn=Ee(a)`
  position: absolute;
  top: calc(50% - 2rem);
  right: ${e=>e.isRight?0:"auto"};
`;var wn=defineMessages({footerLabel:{id:"footer.label",defaultMessage:"Experience by"},footerImageLabel:{id:"footer.image.label",defaultMessage:"SEVENROOMS"}});var Ml="https://sevenrooms.com/guest-thank-you/?utm_source=booking&utm_medium=product&utm_campaign=12_2025_widget";function hy({showTopBorder:e=true}){let{formatMessage:t}=useLocales(),{footer:{height:o}}=c(),r="s";return jsx(v,{height:o,"data-test":"footer",backgroundColor:"primaryBackground",borderTopColor:e?"borders":undefined,alignItems:"center",justifyContent:"center",width:"100%",p:`${r} none`,spacing:r,tabIndex:0,children:jsx(ExperienceBySevenRooms,{href:Ml,experienceByText:t(wn.footerLabel)})})}var Rn=defineMessages({linkAreaLabel:{id:"logoImage.link.areaLabel",defaultMessage:"{name} logo"}});function $n({baseUrl:e$1,target:t="_self",logo:o,logoLabel:r,height:n="100%","data-test":i}){let{formatMessage:a}=useLocales();return jsx(Hl,{height:"100%",cursor:"pointer","data-test":i,children:jsx(e,{lineHeight:"none",children:jsx(Link,{"data-test":"logo-link",to:e$1,isExternal:true,target:t,"aria-label":a(Rn.linkAreaLabel,{name:r}),children:jsx(dn,{"data-test":"logo-image",src:o,height:n,alt:r,fetchPriority:"high"})})})})}var Hl=Ee(a)`
  transition: ${e=>`opacity ${e.theme.animation.duration.logo} ${e.theme.animation.easing.easeInOut}`};

  &:hover {
    opacity: 0.7;
  }
`;function Bt({"data-test":e,ariaLabel:t,width:o,minWidth:r$1,maxWidth:n,maxHeight:i,children:a}){let s=ee.useRef(null),m=typeof o=="number"?`${o}px`:o;return jsx(Dl,{onClick:d=>d.stopPropagation(),"data-test":e,role:"dialog","aria-label":t,width:m,maxHeight:i,children:jsx(Nl,{children:jsxs(zl,{pl:"lm",pr:"lm",children:[jsx(r,{}),jsx(Al,{minWidth:r$1,maxWidth:n,width:m,ref:s,children:a})]})})})}var Dl=Ee.div`
  margin: auto;
  display: flex;
  justify-content: center;
  width: ${({width:e})=>e?`${e}`:"fit-content"};
  max-height: ${({maxHeight:e})=>e??"100%"};
`,zl=Ee(a)`
  display: flex;
  width: 100%;
  max-height: 100%;
`,Al=Ee.div`
  display: flex;
  flex-flow: column;
  margin: 0 auto;
  background-color: ${e=>e.theme.colors.primaryBackground};
  width: ${({width:e})=>e?`${e}`:"min-content"};
  min-width: ${({minWidth:e,theme:t})=>e?`${e}`:t.modal.minimalWidth};
  max-width: ${({maxWidth:e,theme:t})=>e?`${e}`:t.modal.maximumWidth};
  box-shadow: ${e=>e.theme.shadows.tertiary};
  border-radius: ${e=>e.theme.modal.borderRadius};
  overflow: auto;
`;function Mn(e){return jsx(k,{justifyContent:"flex-end",children:jsx(v,{spacing:"s",children:e.children})})}function Ul(e,t){return jsx(TouchScrollable,{children:o=>jsx(a,{pl:"lm",pr:"lm",overflow:"auto",backgroundColor:"primaryBackground",ref:Zn([o,t]),...e,children:e.children})})}var Wn=forwardRef(Ul);function En({children:e,...t}){return jsx(Kl,{p:"lm",...t,children:e})}var Kl=Ee(a)`
  flex-shrink: 0;
  border-bottom-left-radius: ${e=>e.theme.modal.borderRadius};
  border-bottom-right-radius: ${e=>e.theme.modal.borderRadius};
  background: ${e=>e.theme.colors.primaryBackground};
`;function Jl({href:e,size:t,icon:o,iconSize:r,iconColor:n,isExternal:i,...a},s){return jsx(jl,{ref:s,to:e,isExternal:i,size:t,borderType:"none-round",...a,children:jsx(e$1,{size:r,name:o,color:n})})}var Hn=forwardRef(Jl),jl=Ee(Link)`
  ${y}
  text-decoration: none;

  // Need to increase specificity to override a global css style applied by
  // nightloop.css. https://sevenrooms.atlassian.net/browse/ORDER-815
  &&:hover {
    text-decoration: none;
  }
  &:active {
    // Override anchor's default browser style for active link
    color: inherit;
  }
`;function It({children:e,onClose:t,closeHref:o,disabled:r,...n}){return jsxs(ed,{pt:"lm",pb:"m",pl:"lm",pr:"m",...n,children:[e,jsx(td,{children:o?jsx(od,{href:o,size:"s",icon:"VMSWeb-close",iconColor:"primaryIcons",iconSize:"lg","aria-label":"close","data-test":"ui-kit-modal-close"}):jsx(x,{size:"s",borderType:"none-round",icon:"VMSWeb-close",iconColor:"primaryIcons",onClick:t,"aria-label":"close","data-test":"ui-kit-modal-close",disabled:r})})]})}var ed=Ee(a)`
  flex-shrink: 0;
  border-top-left-radius: ${e=>e.theme.modal.borderRadius};
  border-top-right-radius: ${e=>e.theme.modal.borderRadius};
  background: ${e=>e.backgroundColor??e.theme.colors.primaryBackground};
  display: flex;
`,td=Ee(a)`
  flex-shrink: 1;
  align-self: start;
  margin-top: -5px;
  margin-left: auto;
`,od=Ee(Hn)`
  &:focus-visible {
    outline: none;
  }
`;function Nn(e$1){return jsxs(n$1,{spacing:"s",flexGrow:1,children:[jsx("div",{children:jsx(M,{type:"h2","data-test":"modal-title",children:e$1.title})}),e$1.subTitle&&jsx("div",{children:jsx(e,{"data-test":"modal-sub-title",children:e$1.subTitle})})]})}var ot=defineMessages({warning:{id:"unsavedChangesModal.warning",defaultMessage:"Unsaved Changes"},title:{id:"unsavedChangesModal.title",defaultMessage:"Are you sure you want to leave without saving?"},back:{id:"unsavedChangesModal.back",defaultMessage:"Back to Editing"},discard:{id:"unsavedChangesModal.discard",defaultMessage:"Exit Without Saving"}});function ES({onCancel:e,onDiscard:t}){let{formatMessage:o}=useLocales();return jsxs(Bt,{ariaLabel:"Modal",minWidth:528,children:[jsx(It,{pb:"none",onClose:()=>e?.(),children:jsxs(n$1,{spacing:"s",children:[jsx(Z,{kind:"error",children:o(ot.warning)}),jsx(Nn,{title:o(ot.title)})]})}),jsx(En,{children:jsxs(Mn,{children:[jsx(G,{variant:"secondary",onClick:()=>e?.(),"data-test":"unsaved-modal-cancel",children:o(ot.back)}),jsx(G,{variant:"primary-warning",onClick:()=>t?.(),"data-test":"unsaved-modal-save",children:o(ot.discard)})]})})]})}function jS({fieldArray:e,renderItem:t,item:o,label:r,"data-test":n}){return jsxs(n$1,{"data-test":n,spacing:"s",alignItems:"flex-start",children:[e.map((i,a$1,s)=>jsxs(v,{"data-test":`multiline-item-${s}`,spacing:"s",alignItems:"center",children:[t(i,s),jsx(a,{children:e.size()>1?jsx(x,{"data-test":"multiline-remove",borderType:"none-round",size:"s",icon:"VMSWeb-close",onClick:()=>i.remove()}):jsx(a,{p:"m"})})]},a$1.id)),jsxs(G,{"data-test":"multiline-add",variant:"tertiary",noPadding:true,onClick:()=>e.append(o),children:["+\xA0",r]})]})}function Dn({...e}){return jsx(dd,{draggable:false,closeOnClick:false,rtl:false,hideProgressBar:true,...e})}var dd=Ee(ToastContainer)`
  min-width: 436px;

  @keyframes Toastify__fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes Toastify__fadeOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  .Toastify__fade-enter {
    animation: Toastify__fadeIn 0.5s ease-in both;
  }

  .Toastify__fade-exit {
    animation: Toastify__fadeOut 0.5s ease-out both;
  }

  .Toastify__toast-container--bottom-left {
    left: 7em;
  }

  .Toastify__toast {
    min-height: auto;
    padding: ${e=>e.theme.spacing.s} ${e=>e.theme.spacing.m};
    box-shadow: ${e=>e.theme.shadows.secondary};
  }

  .Toastify__toast-body {
    padding: 0;
    font-size: ${e=>e.theme.fontSizes.m};
    line-height: ${e=>e.theme.lineHeights.s};
  }

  .Toastify__toast--error {
    background-color: ${e=>e.theme.colors.error};
  }

  .Toastify__toast--warning {
    background-color: ${e=>e.theme.colors.warning};
  }

  .Toastify__toast--success {
    background-color: ${e=>e.theme.colors.success};
  }

  &.Toastify__toast-container {
    z-index: ${e=>e.theme.zIndex.toaster};
    width: auto;
    min-width: 320px;
    max-width: min-content;
  }

  &.Toastify__toast-body {
    word-break: break-all;
    width: 100%;
  }
`;var bd=cssTransition({enter:"Toastify__fade-enter",exit:"Toastify__fade-exit"}),yd={fade:bd,slide:Slide,bounce:Bounce,zoom:Zoom,flip:Flip};function gC({content:e,type:t="warning",position:o="bottom-left",button:r=jsx(e$1,{name:"VMSWeb-close"}),action:n,autoClose:i=5e3,animation:a="fade",style:s,...m}){let d=r&&(({closeToast:p})=>jsx(Sd,{"data-test":"sr-notification-close-button",variant:"tertiary",onClick:()=>{n?.(),p();},children:r}));toast[t](e,{position:o,closeButton:d,pauseOnHover:true,autoClose:i,style:{zIndex:f.zIndex.toaster,...s},transition:yd[a],...m});}var Sd=Ee(G)`
  padding: 0 ${e=>e.theme.spacing.s};
  color: ${e=>e.theme.colors.lightFont} !important;

  &:focus,
  &:hover,
  &:active {
    color: ${e=>e.theme.colors.lightFont} !important;
  }
`;var Cd={info:"dividerLines",error:"error",warning:"warning",success:"success"},Pd={info:"primaryIcons",error:"error",warning:"warning",success:"success"},vd={info:"infoBackground",error:"errorBackground",warning:"warningBackground",success:"successBackground"},Td={info:"GX-info-outline",error:"GX-warning",warning:"GX-warning",success:"GX-checkbox-marked-circle"};function TC({content:e$2,type:t,showIcon:o,iconName:r,...n}){return jsxs(Jr,{backgroundColor:vd[t],borderColor:Cd[t],flexDirection:"row",alignItems:"center",spacing:"s",p:"m",...n,children:[o&&jsx(k,{alignSelf:"baseline",mt:"xs",children:jsx(e$1,{color:Pd[t],size:"lg",name:r??Td[t],"data-test":"notification-banner-icon"})}),jsx(e,{"data-test":"notification-banner-content",wordBreak:"break-word",children:e$2})]})}function On({show:e,children:t,enableAutoFocus:o=true,enableReturnFocus:r$1=false,enableScrollLock:n=true,enableBackdrop:i=true,enableFocusLock:a=true,shouldCloseOnClick:s$1=true,shouldCloseOnEscapePress:m=true,handleFocusableElements:d=false,onBeforeClose:p=be.noop,onEnter:f=be.noop,onEntering:c=be.noop,onEntered:h=be.noop,onExit:g=be.noop,onExiting:S=be.noop,onExited:b=be.noop}){let[y,P]=useState(e?0:2);useEffect(()=>{e&&y===2&&P(0);},[e,y]);function C(k){P(2),b(k);}function T(){p()!==false&&P(1);}function w(k){k.target===k.currentTarget&&s$1&&T();}let M=useTheme(),_=useMemo(()=>kd.from(M.animation.duration.overlay),[M.animation.duration.overlay]);return y===2?null:jsx(s,{index:M.zIndex.overlay,children:k=>jsx(u$1,{children:jsx(Transition,{appear:true,unmountOnExit:true,in:e&&y!==1,timeout:_,onEnter:f,onEntering:c,onEntered:h,onExit:g,onExiting:S,onExited:C,children:U=>jsx(r,{isActive:n,children:jsxs(Nl,{disabled:!a,autoFocus:o,returnFocus:r$1,children:[jsx(Hd,{enabled:i,zIndex:k,"data-state":U,onClick:w,children:typeof t=="function"?t({state:U,close:T}):t}),jsx(Md,{handleKeys:["esc"],isDisabled:!m,onKeyEvent:T,handleFocusableElements:d})]})})})})})}var Hd=Ee.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${e=>e.zIndex};
  background-color: ${e=>e.enabled?"rgba(10, 10, 10, 0.3)":"transparent"};
  pointer-events: ${e=>e.enabled?"all":"none"};

  > * {
    pointer-events: all;
  }

  ${({theme:{animation:e}})=>css`
    &[data-state='entering'],
    &[data-state='entered'] {
      animation: ${Nd} ${e.duration.overlay} ${e.easing.acceleration} both;
    }

    &[data-state='exiting'],
    &[data-state='exited'] {
      animation: ${Dd} ${e.duration.overlay} ${e.easing.deceleration} both;
    }
  `}
`,Nd=keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`,Dd=keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;function UC({children:e,...t}){return jsx(Od,{pl:"m",...t,children:e})}var Od=Ee(a)`
  border-left: 1px solid ${e=>e.theme.colors.dividerLines};
`;var oe=defineMessages({noResult:{id:"uikit.select.noResult",defaultMessage:"No result"},emptyItem:{id:"uikit.select.emptyItem",defaultMessage:"Empty item"},filterInput:{id:"uikit.select.filterInput",defaultMessage:"Filter input"},toggleLabel:{id:"uikit.select.toggleLabel",defaultMessage:"Toggle menu"},readerLabel:{id:"uikit.select.readerLabel",defaultMessage:"Choose an element"}});var Gn=memo(forwardRef(Yd));function Yd({disabled:e,"data-test":t,options:o,withEmpty:r,hideEmptyOption:n,value:i,onChange:a},s){let{formatMessage:m}=useLocales(),d=typeof o[0]?.id=="number",p=useMemo(()=>r&&!n?[null,...o]:[...o],[n,o,r]),f=useMemo(()=>p.find(c=>c?.id===i),[p,i]);return jsxs(Zd,{disabled:e,"data-test":t,tabIndex:-1,ref:s,"aria-hidden":"true",value:f?.id??"",onChange:c=>{let h=c.target.value??null;a?.(h&&d?Number(h):h);},children:[p.map(c=>jsx("option",{value:c?.id??"","aria-label":c?.label||m(oe.emptyItem),children:c?.label},c?.id??null)),p.length===0&&jsx("option",{disabled:true,children:m(oe.noResult)})]})}var Zd=Ee.select`
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: ${e=>e.theme.zIndex.default};
  opacity: 0;
  cursor: ${e=>e.disabled?"not-allowed":"pointer"};

  @media (hover: hover) and (pointer: fine) {
    display: none;
  }
`;function Ne({children:e,"data-test":t="error-message",...o}){return e?jsx(a,{mt:"xs",children:jsx(i,{"data-test":t,...o,children:e})}):null}function pP({"data-test":e,field:t}){let{errors:o}=useFormState({control:t.control}),r=jd(o,t.name);return r.length===0?null:jsx(Ne,{"data-test":e,children:r.join(" ")})}function Jd(e){return e!=null}function jd(e,t){if(!e)return [];let o=t.split("."),r=e;for(let n of o)if(r!==undefined&&n in r)r=r[n];else return [];return Xn(r)}function ec(e){let t=e.type;return t!==undefined&&typeof t!="object"}function Xn(e){if(e){if(ec(e))return [e.message].filter(Jd)}else return [];let t,o=[];for(t in e){let r=e[t];o.push(Xn(r));}return o.flat()}function ic(e,t){function o(r){typeof e.onClick=="function"&&e.onClick(r);}return jsx(Po,{...e,ref:t,onClick:o,type:"button",children:jsx(e$1,{name:"VMSWeb-chevron-down",color:"primaryIcons"})})}var Lt=forwardRef(ic),ac=css`
  > i {
    transition-property: transform;
    transition-duration: ${e=>e.theme.animation.duration.controls};
    transition-timing-function: ${e=>e.theme.animation.easing.spring};
    transform: ${e=>e.open?"rotate(180deg)":"rotate(0deg)"};
    font-size: ${e=>e.theme.fontSizes.l};
  }
`,Po=Ee.button`
  padding: ${e=>`${e.theme.spacing.sm} ${e.theme.spacing.m} ${e.theme.spacing.sm} ${e.theme.spacing.s}`};
  margin: 0;
  height: 100%;
  border: none;
  outline: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  ${ac}
`;var De=memo(forwardRef(pc));function pc({searchable:e=true,disabled:t,invalid:o$1,initialIsOpen:r,initialInputValue:n$2,contentProps:i,placeholder:a,"data-test":s,useSmartAlignment:m=true,options:d,withEmpty:p$1,hideEmptyOption:f,value:c,onChange:h,errorMessage:g,hideErrorMessage:S,zIndexLayer:b="popover",scrollLock:y,filterIcon:P,hideFilterIcon:C,onFocus:T,onBlur:w$1,name:M,withNativeSupport:_=false,valueIcon:k,displayValue:U,wrapperProps:ue={},alignment:we},Ye){let{formatMessage:F}=useLocales(),ar=useRef(null),qt=useRef(null),sr=useRef([]),[Ze,lr]=useState(false),[dt,dr]=useState(false),{ref:cr,width:ka}=cc(),ct=useMemo(()=>p$1&&!f?[null,...d]:[...d],[f,d,p$1]),{result:qe,setFilter:Qt}=n({options:ct,optionToString:qn,initialFilter:n$2}),Ra=W=>{let D=W?.selectedItem;D!==undefined&&(qt.current?.focus(),h?.(D?.id??null));},{isOpen:Z,openMenu:Jt,closeMenu:mr,inputValue:pr,selectedItem:ke,getToggleButtonProps:fr,getLabelProps:jt,getMenuProps:$a,getInputProps:gr,getComboboxProps:hr,highlightedIndex:Ba,getItemProps:Ia}=useCombobox({items:qe,itemToString:qn,circularNavigation:true,onSelectedItemChange:Ra,initialIsOpen:r,initialInputValue:n$2,selectedItem:ct.find(W=>W?.id===c)??null,stateReducer:(W,{type:D,changes:X})=>{switch(D){case useCombobox.stateChangeTypes.FunctionOpenMenu:{let Qe=W.selectedItem?ct.indexOf(W.selectedItem):undefined;return {...W,...X,inputValue:"",highlightedIndex:Qe}}case useCombobox.stateChangeTypes.InputBlur:case useCombobox.stateChangeTypes.ToggleButtonClick:case useCombobox.stateChangeTypes.FunctionCloseMenu:case useCombobox.stateChangeTypes.FunctionToggleMenu:case useCombobox.stateChangeTypes.ItemClick:case useCombobox.stateChangeTypes.InputKeyDownEnter:case useCombobox.stateChangeTypes.InputKeyDownEscape:{let Qe=(X.selectedItem===null||X.inputValue==="")&&ct[0]!==null;return {...W,...X,inputValue:W.selectedItem?.label??"",...Qe?{selectedItem:W.selectedItem}:{}}}case useCombobox.stateChangeTypes.InputChange:return Z&&Qt(X.inputValue||""),{...W,...X};default:return {...W,...X}}}}),Ma=useCallback(()=>{ke&&sr.current[qe.indexOf(ke)]?.scrollIntoView?.();},[qe,ke]),La=useCallback(()=>{Qt(""),!dt&&!Ze&&w$1?.();},[dt,w$1,Qt,Ze]),Wa=useCallback(W=>jsxs(fa,{open:Z,invalid:o$1,disabled:t,flipped:W.flipped,focused:Ze||dt,...hr({ref:Zn([cr,W.ref])}),"aria-expanded":Z?"true":"false","aria-controls":jt().id,...s&&{"data-test":s},valueIcon:!!k,children:[jsx(da$1,{"aria-label":F(oe.filterInput),tabIndex:Ze?-1:0,searchable:e,selectedValue:ke?.label,displayValue:U,placeholder:a,filterIcon:P,valueIcon:k,hideFilterIcon:C,...s&&{"data-test":`${s}-filter`},...gr({ref:Zn([ar,Ye]),name:M,onFocus:()=>{dr(true),T?.(),Z||Jt();},onBlur:D=>{dr(false),D.relatedTarget!==qt.current&&!Z&&w$1?.();},onMouseDown:()=>{e||(Z?mr():Jt());},disabled:t,value:pr})}),jsx(Lt,{...fr({disabled:t,ref:qt,onFocus:()=>lr(true),onBlur:D=>{lr(false),D.relatedTarget!==ar.current&&!Z&&w$1?.();}}),"aria-label":F(oe.toggleLabel),...s&&{"data-test":`${s}-toggle`},open:Z}),jsx(ha$1,{...jt(),children:i?.["aria-label"]||F(oe.readerLabel)})]}),[mr,i,t,U,P,dt,F,hr,gr,jt,fr,C,pr,o$1,Z,M,w$1,T,Jt,a,Ye,e,ke?.label,cr,s,Ze,k]),Ea=$a({},{suppressRefError:true});return jsxs(n$1,{position:_?"relative":"static",...ue,children:[jsx(w,{show:Z,content:({flipped:W})=>jsxs(p,{width:k?212:ka,flipped:W,...Ea,children:[qe.map((D,X)=>jsx(q,{"aria-label":D?.label??F(oe.emptyItem),label:D?.label,selected:ke===D,highlighted:Ba===X,...Ia({item:D,index:X,ref:Qe=>{sr.current[X]=Qe;}})},D?.id??"empty-item")),qe.length===0&&jsx(o,{children:F(oe.noResult)})]}),onOpen:Ma,onCloseComplete:La,alignment:we,targetOffset:0,bodyOffset:0,contentProps:i,useSmartAlignment:m,zIndexLayer:b,scrollLock:y,"data-test":s?`${s}-popover`:undefined,children:Wa}),!S&&jsx(Ne,{children:g}),_&&!e&&jsx(Gn,{value:c,options:d,disabled:t,onChange:h,"data-test":`${s}-native`,withEmpty:p$1,hideEmptyOption:f})]})}function qn(e){return e?.label??""}var NP=e=>Object.entries(e).map(([t,o])=>({id:t,label:o}));var AP=({max:e,start:t=1,step:o=1,suffix:r="",prefix:n=""})=>{let i=[];for(let a=t;a<=e;a+=o)i.push({id:String(a),label:`${n}${a}${r}`});return i};function Qn({items:e,anchor:t,...o}){let[r,n]=useState(false),{ref:i,width:a}=cc(),s=css`
    width: ${a}px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border: 1px solid ${m=>m.theme.colors.deactivated};
  `;return jsx(A,{onOpen:()=>n(true),onClose:()=>n(false),anchor:jsxs(uc,{open:r,children:[jsx(xc,{pl:"m",children:t}),jsx(bc,{open:r})]}),anchorRef:i,rowsStyles:s,targetOffset:"none",...o,children:e.map(m=>jsx(z,{onClick:m.onClick,children:m.label},m.id))})}var uc=Ee(fa)`
  cursor: pointer;
`,xc=Ee(a)`
  flex: 1;
  align-self: center;
  white-space: nowrap;
  overflow: hidden;
`,bc=Ee(Lt)`
  pointer-events: none;
`;function hv({width:e$1,isShowingSideNavigation:t=true,venueOptions:o,selectedVenueId:r,onVenueChange:n,profileOptions:i,user:a$1}){let{formatMessage:s}=useLocales(),m=d=>jsxs(k,{maxWidth:"170px",alignItems:"center",children:[jsx(a,{mr:"sm",children:jsx(Ar,{firstName:d.first_name,lastName:d.last_name,image:d.photo?.small?`/.h/download/${d.photo.small}`:undefined})}),jsx(e,{textOverflow:"ellipsis",overflow:"hidden",children:d?.first_name})]});return jsxs(vc,{justifyContent:"space-between",width:e$1,isShowingSideNavigation:t,children:[jsx(k,{height:"100%",alignItems:"center",ml:"lm"}),jsxs(v,{height:"100%",spacing:"s",alignItems:"center",justifyContent:"flex-end",mr:"s",children:[jsx(De,{options:o,value:r??null,withEmpty:true,hideEmptyOption:true,onChange:n,placeholder:r?undefined:s(commonMessages.loadingVenues),"data-test":"sr-primary-header-venue-menu"}),a$1&&i&&jsx(Tc,{children:jsx(Qn,{anchor:m(a$1),items:i,"data-test":"sr-primary-header-user-menu"})})]})]})}var Pc=58,vc=Ee(k)`
  width: ${e=>e.width||`calc(100% - (${e.theme.sizes.tabsNavWidth} + ${e.isShowingSideNavigation?e.theme.sizes.sideNavWidth:"0px"}))`};
  height: ${Pc}px;
  position: fixed;
  top: 0;
  background: ${e=>e.theme.colors.primaryBackground};
  z-index: ${f.zIndex.navbar};
  box-sizing: border-box;
`,Tc=Ee.div`
  flex-basis: 140px;
`;var Rc="secondary-header";function Iv({title:e,breadcrumbs:t,description:o,image:r,tab:n,actions:i,top:a$1=0,width:s,maxWidth:m,textMaxWidth:d="640px",onHeightChange:p,isAdmin:f,backgroundImage:c,isShowingSideNavigation:h=true}){let[g,S]=ee.useState(false),b=s$1(g),y=useTheme(),{ref:P,height:C}=D(50,"border-box"),{y:T}=B({y:f?50:j$1(y.spacing.lm)}),{height:w,opacity:M}=useSpring({opacity:g?0:1,height:g?"0%":"100%",config:{duration:150}}),{display:_,lineHeight:k$1,fontSize:U,padding:ue}=useSpring({display:g?"initial":"none",lineHeight:g?y.lineHeights.l:y.lineHeights.xl,fontSize:g?y.fontSizes.xl:y.fontSizes.xxl,padding:g?y.spacing.s:y.spacing.lm,config:{duration:150}});return ee.useEffect(()=>{S(T);},[T]),ee.useEffect(()=>{be.isNumber(C)&&p?.(C);},[C,p]),jsxs(Lc,{id:Rc,"data-test":"secondary-header",style:{paddingTop:ue,paddingBottom:ue},ref:P,top:f&&T?0:a$1,collapsed:g,pl:"lm",pr:"lm",width:s,backgroundImage:c,isShowingSideNavigation:h,children:[t,jsxs(v,{maxWidth:m,justifyContent:"space-between",alignItems:"center",flexGrow:1,ml:f?"auto":"none",mr:f?"auto":"none",mt:t?"m":"none",children:[jsx(k,{alignSelf:"flex-start",children:jsxs(v,{spacing:"m",alignItems:"center",children:[r&&jsx(Ic,{children:r}),jsxs(n$1,{spacing:o&&!g?"s":undefined,alignItems:f?"flex-start":undefined,maxWidth:d,children:[jsxs(k,{alignItems:"center",children:[jsx(a,{mt:g?"s":undefined,mb:g?"s":undefined,children:jsx(ei,{"data-test":"secondary-header-title",style:{lineHeight:k$1,fontSize:U,fontWeight:"bold"},children:e})}),n&&jsxs(ei,{style:{display:_,lineHeight:y.lineHeights.l,fontSize:y.fontSizes.xl},children:["\xA0-\xA0",n]})]}),jsx(Wc,{style:{opacity:M,height:g&&b===g?w:"auto",display:M.to(we=>we===0?"none":"initial")},children:jsx(j,{children:o})})]})]})}),i&&jsx(k,{alignSelf:"flex-start",children:jsx(Bc,{children:i})})]})]})}var $c=Ee(a)`
  ${e=>e.backgroundImage&&css`
      background: ${e.backgroundImage};
    `}

  width: ${e=>e.width||`calc(100% - (${e.theme.sizes.tabsNavWidth} + ${e.isShowingSideNavigation?e.theme.sizes.sideNavWidth:"0px"}))`};
  box-sizing: border-box;
  background-color: ${e=>e.theme.colors.secondaryBackground};
  position: fixed;
  top: ${e=>`${e.top||0}px`};
  z-index: ${e=>e.theme.zIndex.navbar};
  min-height: 58px;

  ${e=>e.isAdmin&&css`
      left: 0;
    `}

  ${e=>e.collapsed&&css`
      box-shadow: ${e.theme.shadows.primary};
    `};
`,Bc=Ee(a)`
  min-height: ${e=>e.theme.fieldHeight.m};
`,Ic=Ee(a)``,Mc=Ee(a)`
  line-height: ${e=>`${e.lineHeight} !important`};
  font-size: ${e=>`${e.fontSize} !important`};
`,ei=animated(Mc),Lc=animated($c),Wc=Ee(animated.div)`
  will-change: opacity, height;
  overflow: hidden;
`;var ti=createGlobalStyle`
  .DayPicker {
    font-size: ${e=>e.theme.fontSizes.m};
    font-family: ${e=>e.theme.fonts.primary};

    &_weekHeader {
      color: ${e=>e.theme.colors.primaryFont};
    }

    &_focusRegion {
      box-shadow: ${e=>e.theme.shadows.tertiary};
    }

    .CalendarMonth_caption {
      color: ${e=>e.theme.colors.primaryFont};
      margin-bottom: ${e=>e.theme.spacing.s};
    }

    .CalendarDay {
      font-weight: 300;
      color: ${e=>e.theme.colors.primaryFont};
      border: 1px solid ${e=>e.theme.colors.dividerLines};

      &__highlighted_calendar {
        font-weight: bold;
        &:not(.CalendarDay__selected):not(:hover) {
          background-color: ${e=>e.theme.colors.primaryBackground};
        }
      }

      &__blocked_out_of_range {
        color: ${e=>e.theme.colors.deactivated};
      }

      &__default {
        &:hover {
          background-color: ${e=>e.theme.colors.dividerLines};
        }
      }

      &__selected {
        background-color: ${e=>e.theme.colors.primaryButton};
        border-color: ${e=>e.theme.colors.primaryButton};
        color: ${e=>e.theme.colors.lightFont};

        &:hover {
          background-color: ${e=>e.theme.colors.primaryHover};
        }
      }

      &__today {
        border: 1px solid ${e=>e.theme.colors.primaryButton};
        position: relative;

        &:before {
          content: '';
          position: absolute;
          top: -1px;
          left: -1px;
          height: calc(100% + 2px);
          background-color: ${e=>e.theme.colors.primaryButton};
          width: 1px;
        }

        &:after {
          content: '';
          position: absolute;
          top: -1px;
          left: 0;
          height: 1px;
          background-color: ${e=>e.theme.colors.primaryButton};
          width: calc(100% + 1px);
        }
      }

      &__blocked_calendar {
        position: relative;
        background-color: ${e=>e.theme.colors.secondaryFont};
        border-color: ${e=>e.theme.colors.secondaryFont};
        color: ${e=>e.theme.colors.lightFont};

        &:before {
          content: '';
          position: absolute;
          top: -1px;
          left: -1px;
          height: calc(100% + 2px);
          background-color: ${e=>e.theme.colors.secondaryFont};
          width: 1px;
        }

        &:after {
          content: '';
          position: absolute;
          top: -1px;
          left: 0;
          height: 1px;
          background-color: ${e=>e.theme.colors.secondaryFont};
          width: calc(100% + 1px);
        }

        &:hover {
          background-color: ${e=>e.theme.colors.secondaryFont};
        }
      }
    }

    th,
    td {
      border: none;
      padding: 0;
    }
  }

  .DayPickerNavigation {
    display: flex;
    justify-content: space-between;
  }
`;function ni({small:e}){let{formatMessage:t}=useLocales();return e?jsx(Nc,{name:t(commonMessages.next),children:jsx(e$1,{name:"VMSWeb-chevron-right"})}):jsx(Hc,{name:t(commonMessages.next),borderType:"none-round",icon:"VMSWeb-chevron-right"})}var Hc=Ee(x)`
  margin-top: 10px;
  margin-right: ${e=>e.theme.spacing.m};
`,Nc=Ee(E$1)`
  margin-top: 23px;
  margin-right: ${e=>e.theme.spacing.s};
`;function si({small:e}){let{formatMessage:t}=useLocales();return e?jsx(Ac,{name:t(commonMessages.previous),children:jsx(e$1,{name:"VMSWeb-chevron-left"})}):jsx(zc,{name:t(commonMessages.previous),borderType:"none-round",icon:"VMSWeb-chevron-left"})}var zc=Ee(x)`
  margin-top: 10px;
  margin-left: ${e=>e.theme.spacing.m};
`,Ac=Ee(E$1)`
  margin-top: 23px;
  margin-left: ${e=>e.theme.spacing.s};
`;function ci({onFocusChange:e,small:t,noBorder:o=false,forceFocus:r=false,onDateChange:n,isDayHighlighted:i,date:a,...s}){let[m,d]=ee.useState(false),p=({focused:c})=>{d(c),e?.({focused:c});},f=c=>{n?.(c?.toDate()||null);};return jsxs(Fragment,{children:[jsx(ti,{}),jsx(Vc,{small:t,noBorder:o,children:jsx(DayPickerSingleDateController,{...s,date:a?Lo(a):null,onDateChange:f,isDayHighlighted:i?c=>i(c.toDate()):undefined,focused:r||m,onFocusChange:p,numberOfMonths:1,hideKeyboardShortcutsPanel:true,navPrev:jsx(si,{small:t}),navNext:jsx(ni,{small:t}),daySize:t?24:40,noBorder:o,initialVisibleMonth:()=>a?Lo(a):Lo()},a?a.getTime():null)})]})}var Vc=Ee.div`
  ${e=>e.small&&css`
      .DayPicker {
        width: 184px !important;
        .CalendarDay {
          font-size: ${e.theme.fontSizes.xs};
          font-weight: 300;

          &__highlighted_calendar {
            font-weight: bold;
            &:not(.CalendarDay__selected):not(:hover) {
              background-color: ${e.theme.colors.primaryBackground};
            }
          }
        }
        .CalendarMonthGrid {
          left: 8px;
        }
        &_transitionContainer,
        &_focusRegion {
          width: 184px !important;
        }
        .CalendarMonth {
          padding: 0 !important;
          &_caption {
            font-size: ${e.theme.fontSizes.l};
            padding-top: ${e.theme.spacing.lm};
            padding-bottom: 28px;
          }
        }
        &_weekHeader {
          padding: 0 !important;
          top: 50px;
        }
      }
    `}

  ${e=>e.noBorder&&css`
      .DayPicker_focusRegion {
        box-shadow: none;
      }
    `}
`;var Ae=Ee(e)`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  @supports (-webkit-line-clamp: 2) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: initial;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;function mi({title:e,id:t,to:o}){let r=useLocation(),n=!!matchPath(r.pathname,{path:o,exact:false,strict:false,sensitive:false});return jsx(R,{"data-test":t,to:o,children:jsx(qc,{pl:"m",pr:"s",pb:"xs",pt:"xs",mb:"xxs",children:jsx(Ae,{color:"secondaryFont",textStyle:n?"body2Medium":"body2",children:e})})})}var qc=Ee(a)`
  cursor: pointer;
  border-radius: 4px;

  &:hover {
    background-color: ${e=>e.theme.colors.secondaryBackground};
  }
`;function Et(e,t){let o=useLocation(),r=useMemo(()=>!!e.find(({to:n})=>!!matchPath(o.pathname,{path:n,exact:false,strict:false,sensitive:false})),[e,o.pathname]);return useState(r?false:t)}var pi='data:image/svg+xml,<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<rect width="14" height="14" rx="7" fill="white"/>%0A<path d="M7 9.635L10.09 11.5L9.27 7.985L12 5.62L8.405 5.31L7 2L5.595 5.31L2 5.62L4.725 7.985L3.91 11.5L7 9.635Z" fill="%23FEC636"/>%0A</svg>%0A';function ui({items:e$2,title:t,to:o,id:r,premium:n,reload:i,collapsedState:a,setCollapsedState:s,exact:m}){let d=useLocation(),{formatMessage:p}=useLocales(),f=useMemo(()=>!!matchPath(d.pathname,{path:o?.split("?")[0]??"",exact:m??false,strict:false,sensitive:false}),[o,m,d.pathname]),[c,h]=Et(e$2,!!a[r]),g=()=>{h(!c),s({...a,[r]:!c});};return jsxs(Fragment,{children:[(()=>{let b=jsxs(sm,{mb:"xxs",pl:"s",pr:"xs",pt:"xs",pb:"xs",justifyContent:"space-between",alignItems:"center",onClick:g,active:f,children:[jsxs(k,{flexDirection:"row",children:[jsx(Ae,{textStyle:f?"body2Medium":"body2",color:f?"primaryNavigation":"secondaryFont",children:t}),n&&jsx("img",{src:pi,width:12,alt:"premium",style:{marginLeft:4}})]}),!be.isEmpty(e$2)&&jsx(E$1,{"aria-label":p(commonMessages.collapse),name:p(commonMessages.collapse),children:jsx(e,{fontSize:"l",children:jsx(e$1,{color:"primaryIcons",name:c?"VMSWeb-chevron-down":"VMSWeb-chevron-up"})})})]});return i?jsx(lm,{"data-test":r,href:o,children:b}):jsx(R,{"data-test":r,to:o,children:b})})(),jsx(me,{collapsed:c,"data-test":`${r}-collapsible`,children:e$2.map(b=>b.allowed!==false&&createElement(mi,{...b,key:b.id}))})]})}var sm=Ee(k)`
  cursor: pointer;
  border-radius: 4px;

  ${e=>e.active?css`
          background-color: ${t=>t.theme.colors.margin};
        `:css`
          &:hover {
            background-color: ${t=>t.theme.colors.secondaryBackground};
          }
        `}
`,lm=Ee.a`
  color: inherit !important;
  text-decoration: none !important;
`;function yi({title:e$2,items:t,id:o,collapsible:r=true,collapsedState:n,setCollapsedState:i}){let{formatMessage:a$1}=useLocales(),[s,m]=Et(t,!!n[o]);return jsxs(Fragment,{children:[jsxs(fm,{justifyContent:"space-between",alignItems:"center",onClick:r?()=>{m(!s),i({...n,[o]:!s});}:undefined,mb:"xs",pr:"xs",children:[jsx(Ae,{textStyle:"body2Medium",color:"primaryNavigation",children:e$2}),r&&jsx(E$1,{"aria-label":a$1(commonMessages.collapse),name:a$1(commonMessages.collapse),children:jsx(e,{fontSize:"l",children:jsx(e$1,{color:"primaryIcons",name:s?"VMSWeb-chevron-down":"VMSWeb-chevron-up"})})})]}),jsx(a,{mb:"s",children:jsx(me,{collapsed:s,"data-test":`${o}-collapsible`,children:t.map(p=>p.allowed!==false&&createElement(ui,{...p,key:p.id,collapsedState:n,setCollapsedState:i}))})})]})}var fm=Ee(k)`
  cursor: pointer;
`;var fw=Ee.input`
  position: absolute;
  margin: 0;
  opacity: 0;
  padding: 0;
  cursor: pointer;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px 1px 1px 1px);
  white-space: nowrap;
`;var Pi=forwardRef(ym);function ym({"data-test":e,border:t,disabled:o,errorMessage:r,fieldHeight:n,fullWidth:i,textTransform:a,hideErrorMessage:s,invalid:m,name:d,onBlur:p,onFocus:f,prefix:c,suffix:h,value:g,...S},b){let[y,P]=useState(false),C=useCallback(M=>{P(false),p?.(M);},[p]),T=useCallback(M=>{P(true),f?.(M);},[f]),w=e??d;return jsxs(n$1,{spacing:"xs",width:"100%","data-test":w?`${w}-container`:undefined,children:[jsxs(Sm,{fullWidth:i,alignItems:"center",textTransform:a,disabled:o,border:t,isFocused:y,invalid:m,fieldHeight:n,children:[c&&jsx(Cm,{children:c}),jsx("input",{...S,"data-test":w,name:d,value:g,ref:b,onFocus:T,onBlur:C,disabled:o}),h&&jsx(Pm,{children:h})]}),!s&&jsx(Ne,{children:r})]})}var Sm=Ee(v)`
  ${e=>css`
    width: 100%;
    max-width: ${e.fullWidth?"100%":e.theme.sizes.fieldMaxWidth};
    background: ${e.theme.colors.inputBackground};
    padding: 0 ${e.fieldHeight==="xs"?e.theme.spacing.s:e.theme.spacing.m};
    border-radius: 4px;
    height: ${e.theme.fieldHeight[e.fieldHeight||"m"]};
    box-sizing: border-box;
    color: ${e.theme.colors.primaryFont};
    font: ${e.fieldHeight==="xs"?e.theme.textStyles.body2:e.theme.textStyles.body1};
    border: ${`1px solid ${e.theme.colors.borders}`};

    &:hover {
      border-color: ${e.disabled?e.theme.colors.borders:e.theme.colors.borderHover};
    }

    &:active {
      border-color: ${e.disabled?e.theme.colors.borders:e.theme.colors.borderFocus};
    }

    &::placeholder {
      color: ${e.theme.colors.secondaryFont};
    }
  `}

  ${e=>e.isFocused&&css`
      && {
        outline: none;
        border-color: ${e.theme.colors.borderFocus};

        ${e.disabled&&css`
          border-color: ${e.theme.colors.borders};
        `}
      }
    `}

  ${e=>e.disabled&&css`
      color: ${e.theme.colors.secondaryFont};
      background-color: ${e.theme.colors.secondaryBackground};
    `}

  ${e=>e.invalid&&css`
      border-color: ${e.theme.colors.error};
    `}

  ${e=>e.border&&css`
      border: ${e.border};
    `}

  & input {
    width: 100%;
    height: 100%;
    padding: 0;
    border: 0;
    box-sizing: border-box;
    background: inherit;
    color: inherit;
    outline: none;
    font-size: inherit;
    font-weight: inherit;

    ${e=>e.textTransform&&css`
        text-transform: ${e.textTransform};
      `}
  }
`,Cm=Ee.div`
  padding-right: 4px;
`,Pm=Ee.div`
  padding-left: 4px;
`;var Ho=defineMessages({placeholder:{id:"sideNavigationSearch.placeholder",defaultMessage:"Search Settings..."},noResultLabel:{id:"sideNavigationSearch.noResultLabel",defaultMessage:"Nothing Found"}});function wi({items:e$1}){let t=useLocation(),o=useTheme(),{formatMessage:r}=useLocales(),n$1=useMemo(()=>Wm(e$1),[e$1]),i=useMemo(()=>Number.parseInt(o.sizes.sideNavWidth)-Number.parseInt(o.sizes.sideNavPadding)*2,[o.sizes.sideNavPadding,o.sizes.sideNavWidth]),{result:a,setFilter:s}=n({options:n$1,optionToString:Ti}),{isOpen:m,setInputValue:d,inputValue:p,getMenuProps:f,getInputProps:c,getComboboxProps:h,highlightedIndex:g,getItemProps:S}=useCombobox({items:a,itemToString:Ti,circularNavigation:true,onInputValueChange:C=>{C.isOpen&&s(C.inputValue??"");},onIsOpenChange:C=>{C.isOpen||d("");},onSelectedItemChange:({selectedItem:C})=>{C?.to&&window.location.replace(C.to);}}),b=f({},{suppressRefError:true}),y=({flipped:C})=>jsxs(Im,{width:i,flipped:C,...b,children:[a.map((T,w)=>jsx(Lm,{pt:"xs",pb:"xs",pr:"s",pl:T.items?"s":"m",highlighted:g===w,...S({item:T,index:w}),children:jsx(e,{textStyle:matchPath(t.pathname,T.to)?.isExact?"body2Medium":"body2",color:T.items?"primaryFont":"secondaryFont",children:T.title})},T.id)),a.length===0&&jsx(Mm,{children:r(Ho.noResultLabel)})]}),P=useCallback(C=>jsx("div",{...h({ref:C.ref}),children:jsx(Pi,{"data-test":"sr-side-navigation-search",fieldHeight:"xs",placeholder:r(Ho.placeholder),...c({value:p})})}),[r,h,c,p]);return jsx(w,{show:m,content:y,alignment:"bottom",targetOffset:2,bodyOffset:0,useSmartAlignment:true,children:P})}var Im=Ee(p)`
  border-radius: 4px;
  overflow-y: auto;
`,Mm=Ee(o)`
  font: ${e=>e.theme.textStyles.body2};
`,Lm=Ee(k)`
  background: ${e=>e.highlighted?e.theme.colors.margin:e.theme.colors.primaryBackground};
`,Wm=e=>{let t=[];return e.filter(o=>o.allowed!==false).forEach(o=>{o.items.filter(r=>r.allowed!==false).forEach(r=>{t=[...t,r,...r.items.filter(n=>n.allowed!==false)];});}),t},Ti=e=>{let t=e?.title??"";return e?.keywords&&(t=`${t} ${e.keywords.join(" ")}`),t};function Ri({venue:e$1,user:t="",items:o,calendar:r,hideVenueName:n=false,hideSearch:i=false,...a}){let s=useTheme(),[m,d]=useState(false),p=useRef(null),{y:f}=B({y:0,ref:p}),[c,h]=o$1({},`sideNavigationCollapsedState_${t}`);useEffect(()=>{d(f);},[f]);let g=s.sizes.sideNavPadding;return jsxs(Am,{...a,children:[!n&&jsx(Om,{padding:g,children:jsx(e,{color:"secondaryFont",textTransform:"uppercase",fontWeight:"bold",children:be.unescape(e$1)})}),r&&jsx(v,{height:"251px",justifyContent:"center",children:jsx(ci,{date:r.date,onDateChange:S=>r?.onDateChange?.(S),isDayHighlighted:r.isDayHighlighted,forceFocus:true,small:true,noBorder:true})}),!i&&jsx(_m,{mt:"s",padding:g,lifted:m,children:jsx(wi,{items:o})}),jsx(Vm,{padding:g,lifted:m,ref:p,children:o.map(S=>S.allowed!==false&&createElement(yi,{...S,key:S.id,collapsedState:c,setCollapsedState:h}))})]})}var Am=Ee(n$1)`
  width: ${e=>e.theme.sizes.sideNavWidth};
  height: 100%;
  max-height: 100vh;
  top: 0;
  position: fixed;
  box-sizing: border-box;
  border-right: 1px solid ${e=>e.theme.colors.dividerLines};
  background: ${e=>e.theme.colors.primaryBackground};
  z-index: ${e=>e.theme.zIndex.navbar};
`,Om=Ee(a)`
  height: ${e=>e.theme.fieldHeight.m};
  margin-top: ${e=>e.theme.sizes.sideNavPadding};
  padding: 0 ${e=>e.padding};
  flex-shrink: 0;
`,_m=Ee(a)`
  padding: 0 ${e=>e.padding} ${e=>e.theme.spacing.lm};
  ${e=>e.lifted&&css`
      box-shadow: ${e.theme.shadows.primary};
    `};
`,Vm=Ee(a)`
  overflow-y: auto;
  padding: 0 ${e=>e.padding} ${e=>e.theme.spacing.s};
  ${e=>e.lifted&&css`
      border-top: 1px solid ${e.theme.colors.dividerLines};
    `};
`;var Pe=defineMessages({rowsPerPage:{id:"uikit.pagination.rowsPerPage",defaultMessage:"Rows per page:"},pagesCount:{id:"uikit.pagination.pagesCount",defaultMessage:"{start}-{end} of {total} items"},firstPage:{id:"uikit.pagination.firstPage",defaultMessage:"First page"},backPage:{id:"uikit.pagination.backPage",defaultMessage:"back"},nextPage:{id:"uikit.pagination.nextPage",defaultMessage:"Next"},lastPage:{id:"uikit.pagination.lastPage",defaultMessage:"Last page"}});var Zm=[10,20,30,40],qm=Zm.map(e=>({id:e.toString(),label:e.toString()}));function $i(e$1){let{formatMessage:t}=useLocales(),o=e$1.options?.length?e$1.options:qm,[r,n]=useState((o.find(s=>s.id===e$1.rowsPerPage.toString())??o[0]).id),i=typeof e$1.totalItemsCount=="number"?Math.min(e$1.rowsPerPage*e$1.currentPage,e$1.totalItemsCount):e$1.rowsPerPage*e$1.currentPage,a$1=s=>{n(s),e$1.onPerPageChange(parseInt(s));};return jsxs(k,{alignItems:"center",children:[jsx(a,{pr:"m",children:jsx(e,{children:t(Pe.rowsPerPage)})}),jsx("div",{style:{width:90},children:jsx(De,{options:o,value:r,onChange:a$1,searchable:false})}),jsx(a,{pl:"l",pr:"l",children:jsx(e,{children:t(Pe.pagesCount,{start:e$1.rowsPerPage*e$1.currentPage-e$1.rowsPerPage+1,end:i,total:e$1.totalItemsCount})})}),jsx(x,{borderType:"none-round",icon:"VMSWeb-page-first","data-test":"ui-kit-pagination-first",onClick:()=>e$1.goToPage("first"),disabled:!e$1.canPreviousPage,title:t(Pe.firstPage)}),jsx(x,{borderType:"none-round",icon:"VMSWeb-chevron-left","data-test":"ui-kit-pagination-prev",onClick:()=>e$1.goToPage("prev"),disabled:!e$1.canPreviousPage,title:t(Pe.backPage)}),jsx(x,{borderType:"none-round",icon:"VMSWeb-chevron-right","data-test":"ui-kit-pagination-next",onClick:()=>e$1.goToPage("next"),disabled:!e$1.canNextPage,title:t(Pe.nextPage)}),!e$1.hideLastPage&&jsx(x,{borderType:"none-round",icon:"VMSWeb-page-last","data-test":"ui-kit-pagination-last",onClick:()=>e$1.goToPage("last"),disabled:!e$1.canNextPage,title:t(Pe.lastPage)})]})}function Ik(e$1){return jsxs(kt,{gridTemplateColumns:"repeat(12, 1fr)",gap:"lm",gridAutoRows:"min-content",children:[jsx(a,{maxWidth:"100%",gridColumn:"auto / span 4",children:jsx(e,{fontSize:"m",children:e$1.left})}),jsx(a,{maxWidth:"100%",gridColumn:"auto / span 8",children:jsx(e,{fontSize:"m",textOverflow:e$1.textOverflow,children:e$1.right})})]})}function jm({primary:e$1,secondary:t,label:o,onClick:r}){return jsxs(n$1,{p:"lm",children:[jsx(M,{type:"h2",children:e$1}),jsx(a,{pt:"m",children:jsx(e,{children:t})}),o&&r&&jsx(k,{justifyContent:"flex-end",pt:"l",pb:"s",children:jsx(Ii,{"data-test":`sr-${o}-button`,variant:"secondary",size:"s",onClick:r,children:o})})]})}function ep({primary:e,secondary:t,label:o,onClick:r}){return jsxs(v,{pt:"m",pb:"m",pl:"lm",pr:"lm",spacing:"3xl",children:[jsxs(n$1,{flexGrow:1,children:[jsx(M,{type:"h2",children:e}),jsx(a,{pt:"xs",children:jsx(j,{children:t})})]}),o&&r&&jsx(k,{alignItems:"center",children:jsx(Ii,{"data-test":`sr-${o}-button`,variant:"secondary",size:"s",onClick:r,children:o})})]})}function Vk({size:e="l",...t}){return jsx(op,{size:e,children:e==="s"?jsx(jm,{...t}):jsx(ep,{...t})})}var tp={xl:"968px",l:"920px",s:"448px"},op=Ee(a)`
  max-width: ${e=>tp[e.size]};
  background-color: ${e=>e.theme.colors.margin};
  border-radius: 10px;
  box-shadow: ${e=>e.theme.shadows.primary};
`,Ii=Ee(G)`
  background-color: ${e=>e.theme.colors.inputBackground};
`;function Zk(e){return jsx(rp,{children:jsx(np,{children:e.children})})}var rp=Ee.table`
  background: inherit;
  width: 100%;
  border: none;
  border-spacing: 0;
  border-collapse: separate;
`,np=Ee.tbody`
  background: inherit;
`;function o0(e$1){let{count:t$1,clearChildren:o}=t(e$1.children);return t$1===0?null:jsxs(ip,{children:[jsx(ap,{firstColWidth:e$1.firstColWidth,children:jsx(a,{p:"xs",children:jsx(e,{children:e$1.name})})}),Array.isArray(o)?o.map((r,n)=>jsx(zo,{colWidth:e$1.colWidth,children:jsx(a,{p:"xs",children:jsx(e,{children:r})})},n)):jsx(zo,{colWidth:e$1.colWidth,children:jsx(a,{p:"xs",children:jsx(e,{children:o})})})]})}var ip=Ee.tr``,zo=Ee.td`
  border: none;
  padding: 0;
  border-bottom: 1px solid ${e=>e.theme.colors.dividerLines};
  width: ${e=>e.colWidth??"initial"};
  vertical-align: top;
`,ap=Ee(zo)`
  width: ${e=>e.firstColWidth??"324px"};
`;function d0(e$1){let{count:t$1,clearChildren:o}=t(e$1.children);return t$1===0?null:jsxs(Fragment,{children:[e$1.caption!==undefined&&jsx(lp,{position:e$1.position,children:Array.isArray(e$1.caption)?e$1.caption.map((r,n)=>jsx(Wi,{children:jsx(a,{p:"xs",children:jsx(e,{fontWeight:"bold",children:r})})},n)):jsx(Wi,{colSpan:2,children:jsx(a,{p:"xs",children:jsx(e,{fontWeight:"bold",children:e$1.caption})})})}),o,jsx(dp,{children:jsx(Ei,{children:jsx(a,{p:"m"})})})]})}var lp=Ee.tr`
  position: ${e=>e.position||"sticky"};
  top: 0;
  background: inherit;
`,Ei=Ee.td`
  border: none;
  padding: 0;
`,Wi=Ee(Ei)`
  border-bottom: 2px solid ${e=>e.theme.colors.dividerLines};
`,dp=Ee.tr`
  :last-child {
    display: none;
  }
`;function y0(e){return jsxs(pp,{children:[jsx(fp,{pl:"m",pr:"m",pt:"s",pb:"s",children:jsx(M,{type:"h4",children:e.title})}),jsx(gp,{p:"m",children:e.children})]})}var _o="4px",pp=Ee.div`
  background: ${e=>e.theme.colors.secondaryBackground};
  border-radius: ${_o};
`,fp=Ee(a)`
  background: ${e=>e.theme.colors.dividerLines};
  border-top-left-radius: ${_o};
  border-top-right-radius: ${_o};
`,gp=Ee(a)`
  background: inherit;
`;var[Fi,Hi]=a$1();function zi(e){let t=useTheme(),o=Hi(),[r,n]=ee.useState([]),i=r.length>0,a=ee.useCallback(c=>{n(h=>[...h,c]);},[]),s=ee.useCallback(c=>{n(h=>h.filter(g=>g.key!==c.key));},[]),d=useTransition(r,{key:c=>c.key,config:{duration:150},from:{opacity:0,transform:"translateY(0px)",pointerEvents:"none"},enter:{opacity:1,transform:`translateY(${t.modal.topOffset}px)`,pointerEvents:"all"},leave:{opacity:0,transform:"translateY(0px)",pointerEvents:"none"},update:(c,h)=>({opacity:h===r.length-1?1:0,transform:`translateY(${h===r.length-1?t.modal.topOffset:0}px)`,pointerEvents:h===r.length-1?"all":"none"})})((c,h)=>o.dom&&jsx(Cp,{ref:h.setNode,style:{transform:c.transform,opacity:c.opacity,pointerEvents:c.pointerEvents}},h.key)),p=ee.useMemo(()=>({register:a,unregister:s,hasOpenedItems:i}),[a,s,i]),f=ee.useCallback(()=>{r.at(-1)?.close();},[r]);return ee.useEffect(()=>{let c=h=>{h.code==="Escape"&&f();};return document.addEventListener("keydown",c),()=>{document.removeEventListener("keydown",c);}},[f,r]),jsxs(Sp,{value:p,children:[o.dom&&Di.createPortal(jsx(Gr,{onClick:f,isActive:i,"data-test":"ui-kit-backdrop",children:d}),o.dom),e.children]})}var [Sp,Ai]=a$1(),Cp=Ee(animated.div)`
  position: absolute;
  display: flex;
  will-change: transform, opacity, pointer-events;
  width: 100%;
  height: calc(100% - ${e=>e.theme.modal.topOffset*2}px);
`;var Mp={vx:vmsTheme,gx:gxTheme},Lp={vx:e$2,gx:h$1},Wp={vx:d,gx:g$1};function Y0({children:e,theme:t,themeOverride:o,locale:r,messages:n}){let[i,a]=ee.useState(null),s=ee.useMemo(()=>({dom:i}),[i]),m=useMemo(()=>Lp[t](be.merge(Wp[t],o)),[t,o]);return jsx(LocaleRoot,{locale:r,messages:n,children:jsx(ThemeProvider,{theme:m,children:jsxs(ThemeProvider$1,{theme:Mp[t],children:[jsx(Normalize,{}),jsxs(Fi,{value:s,children:[jsx(zi,{children:e}),jsx("div",{"data-test":"ui-kit-portal-root",ref:a})]}),jsx(Dn,{})]})})})}function oR(e){let t=useRef(null),[o,r]=useState(1);return useLayoutEffect(()=>{let n=1,i=t.current?.parentElement;i&&(e.scaleWidth&&!e.scaleHeight?(n=Math.min(t.current.parentElement.offsetWidth/t.current?.offsetWidth,1),e.updateSize&&(i.style.height=`${i.clientHeight*n}px`)):e.scaleHeight&&!e.scaleWidth?(n=Math.min(t.current.parentElement.offsetHeight/t.current?.offsetHeight,1),e.updateSize&&(i.style.width=`${i.clientWidth*n}px`)):(n=Math.min(t.current.parentElement.offsetWidth/t.current?.offsetWidth,t.current.parentElement.offsetHeight/t.current?.offsetHeight,1),e.updateSize&&(i.style.width=`${i.clientWidth*n}px`,i.style.height=`${i.clientHeight*n}px`)),r(n));},[t,e.scaleWidth,e.scaleHeight,e.updateSize]),jsx(a,{width:"100%",height:"100%",children:jsx(Dp,{scale:o,ref:t,children:e.children})})}var Dp=Ee(a)`
  width: fit-content;
  overflow: hidden;
  transform-origin: 0 0 0;
  transform: ${e=>`scale(${e.scale})`};
`;function Vi({type:e$1="h2",title:t,subCaption:o,description:r,hideDescriptionOnCollapse:n,collapsed:i,...a$1}){let s=n?i:false;return jsxs(Fragment,{children:[jsx(a,{mb:r?"xs":undefined,children:jsx(M,{type:e$1,...a$1,children:t})}),o&&jsx(a,{mt:"xs",mb:"xs",children:jsx(e,{fontSize:"m",children:o})}),r&&!s&&jsx(j,{children:r})]})}function Gi({title:e,type:t,subCaption:o,description:r,hideDescriptionOnCollapse:n,actions:i,collapsed:a$1,onToggleCollapse:s,hasError:m,ml:d,mr:p,mb:f,mt:c}){let h=p$1("s");return jsxs(Fragment,{children:[jsxs(k,{width:"100%",justifyContent:"space-between",flexWrap:"wrap",children:[jsx(k,{flexBasis:"40%",flexGrow:1,flexShrink:1,minWidth:"100px",alignItems:r?undefined:"center",children:jsx(a,{children:jsx(Vi,{ml:d,mr:p,mb:f,mt:c,title:e,type:t,subCaption:o,description:r,hideDescriptionOnCollapse:n,collapsed:a$1})})}),jsxs(k,{flexGrow:0,flexShrink:0,alignItems:h?"center":"flex-start",children:[!h&&i,s&&jsx(a,{ml:d||i?"s":undefined,mt:c||"xs",mr:p,mb:f,children:jsx(K,{"aria-expanded":a$1?"false":"true",onClick:s?()=>s(!a$1):undefined,size:"s",collapsed:a$1,disabled:m,"data-test":"sectionContent-collapseButton"})})]})]}),h&&i&&jsx(k,{width:"100%",children:i})]})}function At({title:e,type:t,subCaption:o,description:r,hideDescriptionOnCollapse:n,actions:i,contentWhenCollapsed:a$1,maxWidth:s,hasError:m,children:d,backgroundColor:p,padding:f="lm",ml:c,mr:h,mb:g,mt:S,borderWidth:b=1,"data-test":y,...P}){return jsxs(Vp,{maxWidth:s,"data-test":y,backgroundColor:p,borderWidth:b,children:[!!(e||r||o||i)&&jsx(a,{pr:f,pl:f,pt:f,children:jsx(Gi,{ml:c,mr:h,mb:g,mt:S,type:t,title:e,subCaption:o,description:r,hideDescriptionOnCollapse:n,actions:i,hasError:m,...P})}),P.collapsed&&(a$1?jsxs(Fragment,{children:[jsx(a,{pb:"sm"}),jsx(a,{pl:f,pr:f,children:jsx(nn,{margin:"none"})}),a$1]}):jsx(a,{pb:f})),P.collapsed?null:jsx(me,{collapsed:P.collapsed,children:d})]})}var Vp=Ee.section`
  background: ${e=>e.backgroundColor?e.theme.colors[e.backgroundColor]:"white"};
  border-radius: 4px;
  max-width: ${({maxWidth:e})=>e??"968px"};
  border: ${e=>`${e.borderWidth}px solid ${e.theme.colors.dividerLines}`};
`;function Yp({behavior:e,localStoragePrefix:t}){let o=useMemo(()=>new Map,[]),r=useCallback(async n=>{let i=o.get(n)?.(),{collapsed:a,canCollapse:s,onToggleCollapse:m}=i??{};if(a||await s?.()){if(e==="one-section-at-one-time"){let d=Array.from(o.entries()).filter(([c])=>c!==n).map(([c,h])=>h()).filter(c=>!c.collapsed);if(!(await Promise.all(d.map(c=>c.canCollapse()))).every(c=>c))return  false;for(let c of d)c.onToggleCollapse(true);}}else return  false;return m?.(!a),true},[e,o]);return {sections:o,tryToggleSection:r,localStoragePrefix:t,behavior:e}}var [FR,Zp]=Up(Yp);function Yi(e,{canCollapse:t,onToggleCollapse:o,initiallyCollapsed:r}={}){let[n]=useState(e),{sections:i,tryToggleSection:a,localStoragePrefix:s,behavior:m}=Zp(),d=useMemo(()=>{try{let g=Array.from(i.entries()).map(([S,b])=>b()).some(S=>!S.collapsed);return r||g&&m==="one-section-at-one-time"}catch(g){if(g instanceof TypeError){let S=new SyntaxError("Section must be used within a SectionController");throw S.stack=g.stack,S}else throw g}},[i,m,r]),[p,f]=o$1(d,s?`sectionCollapsedState_${s}_${n}`:undefined),c=b$1({canCollapse:t??(async()=>true),onToggleCollapse:g=>{o?.(g),f(g);},collapsed:p});return useEffect(()=>{n!==e&&console.warn(`Section name changed! You may experience unexpected behavior. ${n} -> ${e}`);let g=c();return g.canCollapse().then(S=>{S||g.onToggleCollapse(false);}),()=>{i.delete(e);}},[e,n,i,c]),i.set(e,c),{tryToggleCollapse:useCallback(()=>a(n),[a,n]),collapsed:p}}function zR({initiallyCollapsed:e,name:t,onToggleCollapse:o,canCollapse:r,...n}){let{collapsed:i,tryToggleCollapse:a}=Yi(t,{initiallyCollapsed:e,canCollapse:r,onToggleCollapse:o});return jsx(At,{...n,collapsed:i,onToggleCollapse:a})}function GR({initiallyCollapsed:e,localStorageKey:t,...o}){let[r,n]=o$1(!!e,t?`simpleSectionCollapsedState_${t}`:undefined);return jsx(At,{...o,collapsed:r,onToggleCollapse:()=>n(i=>!i)})}function n$({"data-test":e$1,...t}){return jsxs(a,{"data-test":e$1,children:[jsxs(a,{pb:"lm",children:[jsx(a,{pb:"s",children:jsx(M,{type:t.type,children:t.header})}),jsx(e,{color:"secondaryFont",children:t.description})]}),t.children]})}var m$=Ee(l)`
  background: linear-gradient(188deg, rgba(214, 169, 232, 0.5) 6.26%, rgba(119, 210, 249, 0.2) 95.58%);
`;var u$=Ee.div`
  padding-top: ${e=>e.paddingTop}px;
  width: 100%;
  height: 100%;
  background: ${e=>e.theme.colors.secondaryBackground};
`;function P$({calendar:e,children:t,hideSearch:o,hideVenueName:r,showSideNavigation:n,sideNavigationItems:i,userId:a,venueInternalDisplayName:s}){return jsxs(Fragment,{children:[n&&a&&jsx(Ri,{venue:s??"",user:a??"",items:i??[],calendar:e,hideVenueName:r,hideSearch:o}),jsx(of,{showSideNavigation:n,children:t})]})}var of=Ee.main`
  margin-left: ${e=>e.showSideNavigation?e.theme.sizes.sideNavWidth:0};
  height: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  background: ${e=>e.theme.colors.secondaryBackground};
  flex-grow: 1;

  ${e=>e.showSideNavigation&&css`
      width: 100%;
      max-width: calc(100% - 194px);
    `}
`;function H$({title:e$2,subtitle:t,description:o,draggable:r,actions:n,collapsible:i,defaultCollapsed:a$1,size:s="l",memoCollapseState:m,children:d,...p}){let[f,c]=o$1(!!a$1,m?`sectionCollapsedState_${m}`:undefined);return jsxs(af,{size:s,...p,children:[jsxs(sf,{pr:"s",pl:"s",pt:o?"s":"xs",pb:o?"s":"xs",alignItems:"center",children:[r&&jsx(a,{pl:"xs",pr:"xs",children:jsx(e$1,{name:"VMSWeb-drag",color:"deactivated"})}),jsxs(lf,{pl:"s",pr:"sm",flexDirection:"column",justifyContent:"center",flex:"auto",children:[(e$2||t)&&jsxs(Qi,{children:[e$2&&jsx(e,{fontWeight:"bold",children:e$2}),e$2&&t&&jsx(e,{children:" - "}),t&&jsx(e,{children:t})]}),o&&jsx(Qi,{pt:"xs",children:jsx(j,{children:o})})]}),n&&jsx(A,{anchor:jsx(x,{borderType:"none-round",icon:"VMSWeb-more-vertical",size:"s","data-test":"settingsSection-menuButton"}),children:n}),i&&jsx(a,{ml:"s",children:jsx(K,{size:"s",collapsed:f,onToggle:c,"data-test":"settingsSection-collapseButton"})})]}),jsx(me,{collapsed:f,children:d})]})}var af=Ee.section`
  max-width: ${e=>e.size==="l"?"920px":"448px"};
`,sf=Ee(k)`
  background: ${e=>e.theme.colors.secondaryBackground};
  border-radius: 4px;
`,lf=Ee(k)`
  width: 0;
  min-height: ${e=>e.theme.spacing.l};
  font-size: ${e=>e.theme.fontSizes.m};
`,Qi=Ee(a)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;function cf({show:e,...t},o){return jsx(mf,{...t,ref:o,display:e?"flex":"none",backgroundColor:"overlayBackground",position:"absolute",overflow:"hidden"})}var G$=ee.forwardRef(cf),mf=Ee(k)`
  transition: ${f.animation.duration.overlay} ease;
  gap: ${e=>e.theme.spacing.m};
  lex: none;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
`;function ji({children:e,close:t}){return jsx(s,{children:o=>jsx(gf,{zIndex:o,pr:"lm",pl:"lm",children:e?jsx(e.type,{...e.props,close:t}):null})})}var gf=Ee(a)`
  display: flex;
  align-items: center;
  background: ${e=>e.theme.colors.primaryBackground};
  box-shadow: 0px -2px 4px rgba(9, 34, 56, 0.1);
  height: 58px;
  width: 100%;
`;function ea({title:e,onClose:t,showCloseButton:o=true}){return jsx(s,{children:r=>jsxs(uf,{pl:"lm",pr:"sm",zIndex:r,children:[jsx(M,{type:"h2",children:e}),o&&jsx(x,{"data-test":"ui-kit-slideout-close",borderType:"none-round",icon:"VMSWeb-close",onClick:t,"aria-label":"Close"})]})})}var uf=Ee(a)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${e=>e.theme.colors.primaryBackground};
  box-shadow: 0 2px 4px rgba(9, 34, 56, 0.1);
  height: 58px;
  width: 100%;

  h2 {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  button {
    flex-shrink: 0;
  }
`;function pB({show:e,title:t,background:o,noTopPadding:r,width:n=800,children:i,enableBackdrop:a=false,enableFocusLock:s=false,enableAutoFocus:m=true,enableReturnFocus:d=false,enableScrollLock:p=false,handleFocusableElements:f=false,footer:c=null,shouldCloseOnClick:h=false,shouldCloseOnEscapePress:g=true,showCloseButton:S=true,onBeforeClose:b=be.noop,onCloseComplete:y=be.noop,onOpenComplete:P=be.noop,"data-test":C}){return jsx(On,{show:e,enableBackdrop:a,enableFocusLock:s,enableAutoFocus:m,enableReturnFocus:d,enableScrollLock:p,shouldCloseOnClick:h,shouldCloseOnEscapePress:g,onExited:y,onEntered:P,onBeforeClose:b,handleFocusableElements:f,children:({state:T,close:w})=>jsxs(yf,{"data-test":C,width:n,"data-state":T,children:[jsx(ea,{title:t,onClose:w,showCloseButton:S}),jsx(bf,{noTopPadding:r,background:o,children:typeof i=="function"?i({close:w}):i}),jsx(ji,{close:w,children:c})]})})}var bf=Ee.div`
  flex: 1;
  flex-basis: ${({width:e})=>typeof e=="string"?e:`${e}px`};
  overflow: auto;
  background: ${e=>e.theme.colors[e.background??"primaryBackground"]};
  padding: ${e=>`${e.theme.spacing.l} ${e.theme.spacing.lm}`};

  ${e=>e.noTopPadding&&css`
      padding-top: 0;
    `}
`,yf=Ee.div`
  position: absolute;
  left: auto;
  right: 0;
  height: 100vh;
  max-height: 100%;
  width: ${({width:e})=>typeof e=="string"?e:`${e}px`};
  max-width: 100vw;
  transform: translateX(100%);
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 8px rgba(9, 34, 56, 0.1);

  ${({theme:{animation:e}})=>css`
    &[data-state='entering'],
    &[data-state='entered'] {
      animation: ${Sf} ${e.duration.slideOut} ${e.easing.deceleration} both;
    }
    &[data-state='exiting'],
    &[data-state='exited'] {
      animation: ${Cf} ${e.duration.slideOut} ${e.easing.acceleration} both;
    }
  `}
`,Sf=keyframes`
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
`,Cf=keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(100%); }
`;function PB({title:e$1,description:t,actions:o,collapsible:r,collapsed:n,children:i,onClick:a$1,...s}){return jsxs(wf,{highlightOnHover:n&&!!a$1,...s,children:[!!(e$1||t||o||r)&&jsx(kt,{gridTemplateColumns:"repeat(12, 1fr)",gap:"lm",gridAutoRows:"min-content",children:jsx(jr,{maxWidth:"100%",gridColumn:"auto / span 12","data-test":"ui-kit-slideout-subsection-clickable",onClick:a$1,children:jsx(a,{pr:"lm",pl:"lm",pt:"m",children:jsxs(k,{flexDirection:"column",children:[jsx(a,{children:jsxs(k,{justifyContent:"space-between",alignItems:"center",children:[jsx(a,{children:jsx(M,{type:"h3",children:e$1})}),jsx(k,{children:o})]})}),jsx(a,{children:jsx(e,{children:t})})]})})})}),i]})}var wf=Ee.section`
  background: white;
  border-radius: 10px;
  max-width: 752px;
  border: ${e=>`1px solid ${e.theme.colors.borders}`};
  overflow: hidden;
  ${e=>e.height&&`height: ${e.height};`}
  ${e=>e.highlightOnHover&&css`
      &:hover {
        border: 1px solid ${e.theme.colors.secondaryFont};
      }
    `}
`;var na=Ee.table`
  height: 1px;
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  border-style: hidden;
  box-sizing: border-box;
  margin-bottom: 0;

  th,
  td {
    border: none;
    padding: 0;
  }
`;var ia=Ee.tbody``;function Ut(e$1){return jsx(Bf,{as:e$1.isHeader?"th":undefined,...e$1,children:jsx(te,{...e$1,children:jsx($f,{...e$1,children:jsx(e,{fontSize:"m",type:"div",width:"100%",fontWeight:e$1.isHeader?"bold":undefined,textDisplay:e$1.textDisplay,justifyContent:e$1.justifyContent,textAlign:e$1.textAlign,children:e$1.children})})})})}var $f=Ee.div`
  display: ${e=>e.displayBlock?"block":"flex"};
  padding: 19px ${e=>`${e.theme.spacing.m}`};
  height: 100%;
  width: 100%;
  align-items: ${e=>e.alignItems??"center"};
  box-sizing: border-box;

  justify-content: ${e=>{switch(e.justifyContent){case undefined:case "center":return e.justifyContent;default:return `flex-${e.justifyContent}`}}};

  ${e=>e.removeRightPadding&&css`
      padding-right: 0;
    `}

  ${e=>e.backgroundColor&&css`
      background-color: ${e.theme.colors[e.backgroundColor]};
    `}

  ${e=>e.removeLeftPadding&&css`
      padding-left: 0;
    `}

  ${e=>e.shouldAddNestingPadding&&css`
      padding-left: ${e.theme.spacing.l};
    `}

    ${e=>e.removePadding&&css`
      padding: 0;
    `}
`,te=Ee.div`
  min-height: 54px;
  border-bottom: ${e=>e.noBorderBottom?"none":`1px solid ${e.theme.colors.borders}`};
  border-left: ${e=>e.borderLeft?`1px solid ${e.theme.colors.borders}`:"none"};
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;

  ${e=>e.isHeader&&css`
      white-space: nowrap;
      height: 100%;
      border-top: ${e.noTopBorder?"none":`1px solid ${e.theme.colors.borders}`};
    `};
`,Bf=Ee.td`
  background: ${e=>e.isNested?e.theme.colors.secondaryBackground:"white"};
  padding: 0;
  height: 100%;
  box-sizing: border-box;
  ${e=>e.isHeader&&css`
      text-align: ${e.headerAlign||"left"};
    `};

  ${e=>e.attach==="left"&&css`
      position: sticky;
      left: 0;
      z-index: ${e.isHeader?1:0};

      & > ${te} {
        box-shadow: ${e.noBoxShadow?"none":`2px 0px 3px ${e.theme.shadows.primaryColor}`};
      }
    `};

  ${e=>e.isHeader&&css`
      position: sticky;
      top: 0;
      z-index: ${e.attach===undefined?0:1};

      ${te} {
        box-shadow: ${e.noBoxShadow?"none":`2px 0px 3px ${e.theme.shadows.primaryColor}`};
      }
    `}

  ${e=>e.attach==="right"&&css`
      position: sticky;
      right: 0;
      z-index: ${e.isHeader?1:0};

      & > ${te} {
        box-shadow: ${e.noBoxShadow?"none":`-2px 0px 3px ${e.theme.shadows.primaryColor}`};
      }
    `};

  &:first-child > ${te} {
    border-left: ${e=>e.noBorder?"none":`1px solid ${e.theme.colors.borders}`};
  }

  &:last-child > ${te} {
    border-right: ${e=>e.noBorder?"none":`1px solid ${e.theme.colors.borders}`};
  }

  ${e=>e.isInFirstRow&&css`
      &:first-child > ${te} {
        border-top-left-radius: ${t=>t.theme.table.borderRadius};
      }

      &:last-child > ${te} {
        border-top-right-radius: ${t=>t.theme.table.borderRadius};
      }
    `};

  ${e=>e.isInLastRow&&css`
      &:first-child > ${te} {
        border-bottom-left-radius: ${t=>t.theme.table.borderRadius};
      }

      &:last-child > ${te} {
        border-bottom-right-radius: ${t=>t.theme.table.borderRadius};
      }
    `};

  ${({width:e})=>e&&css`
      width: ${typeof e=="string"?e:`${e}px`};
    `}

  ${({minWidth:e})=>e&&css`
      min-width: ${typeof e=="string"?e:`${e}px`};
    `}

  ${({maxWidth:e})=>e&&css`
      max-width: ${typeof e=="string"?e:`${e}px`};
    `}
`;var zB=Ee.tfoot``;var _B=Ee.thead``;var sa=Ee.tr`
  ${e=>e.hoverOnRows&&css`
      &:hover td {
        cursor: pointer;
        background: ${t=>t.theme.colors.secondaryBackground};
      }
    `}

  ${e=>e.isSelected&&css`
      && {
        td {
          background: ${t=>t.theme.colors.margin};
        }
      }
    `}
`;function da(e){let{formatMessage:t}=useLocales();return jsx(Fragment,{children:e.row.canExpand?jsxs(k,{alignItems:"center",onClick:o=>{o.stopPropagation();},children:[e.value,jsx(a,{p:"s",children:jsx(x,{"data-test":"ui-kit-spreadsheet-expand-cell",...e.row.getToggleRowExpandedProps({}),title:t(e.row.isExpanded?commonMessages.collapse:commonMessages.expand),borderType:"none-round",icon:e.row.isExpanded?"VMSWeb-chevron-down":"VMSWeb-chevron-right"})})]}):e.value})}function ca(e){let t=ee__default.useCallback(o=>{switch(o){case "first":return e.table.gotoPage(0);case "prev":return e.table.previousPage();case "next":return e.table.nextPage();case "last":return e.table.gotoPage(e.table.pageCount-1);default:return e.table.gotoPage(o)}},[e.table]);return jsx(k,{justifyContent:"flex-end",children:jsxs(Nf,{children:[jsx(Df,{noBorder:e.noBorder}),jsx(zf,{noBorder:e.noBorder,children:jsx($i,{currentPage:e.table.state.pageIndex+1,totalItemsCount:e.totalItemsCount,rowsPerPage:e.table.state.pageSize,canPreviousPage:e.table.canPreviousPage,canNextPage:e.table.canNextPage,onPerPageChange:e.table.setPageSize,goToPage:t})})]})})}var Nf=Ee.div`
  background: ${e=>e.theme.colors.primaryBackground};
  width: 100%;
  display: inline-flex;
  justify-content: flex-end;
  border-top: 1px solid ${e=>e.theme.colors.borders};
`,Df=Ee.div`
  position: sticky;
  width: 100%;
  left: 0;
  margin-right: auto;
  border-bottom: ${e=>e.noBorder?"none":`1px solid ${e.theme.colors.borders}`};
  border-left: ${e=>e.noBorder?"none":`1px solid ${e.theme.colors.borders}`};
  border-bottom-left-radius: ${e=>e.theme.table.borderRadius};
`,zf=Ee.div`
  position: sticky;
  min-width: max-content;
  right: 0;
  padding: ${e=>`${e.theme.spacing.m} ${e.theme.spacing.lm}`};
  border-bottom: ${e=>e.noBorder?"none":`1px solid ${e.theme.colors.borders}`};
  border-right: ${e=>e.noBorder?"none":`1px solid ${e.theme.colors.borders}`};
  border-bottom-right-radius: ${e=>e.theme.table.borderRadius};
`;function pa({pin:e,...t}){let o=useRef(null);useEffect(()=>{let n=be.debounce(()=>{let i=document.querySelector("html");if(o.current&&i&&e){let a=e?e.getBoundingClientRect().bottom:0;if(i.scrollTop>=o.current.offsetTop-a){let s=i.scrollTop-o.current.offsetTop+a;o.current.setAttribute("style",`transition:0s; transform: translate3d(0px, ${s}px, 0px);`);}else o.current.setAttribute("style","transition:0s; transform: translate3d(0px, 0px, 0px);");}},200);return e&&window.addEventListener("scroll",n),()=>{window.removeEventListener("scroll",n);}},[e]);function r(n,i){let a=n;return typeof a.spreadsheetColumn.header=="string"&&a.spreadsheetColumn.header.length?{"data-test":`ui-kit-spreadsheet-${i}-${a.spreadsheetColumn.header}`}:{}}return jsx(Uf,{ref:o,children:t.headerGroups.map(n=>jsx("tr",{...n.getHeaderGroupProps(),children:n.headers.map(i=>jsxs(Ut,{...i.getHeaderProps(i.getSortByToggleProps()),isHeader:true,isInFirstRow:!t.hideTopCorners,noBoxShadow:t.noBoxShadow,textDisplay:i.spreadsheetColumn.textDisplay,justifyContent:i.spreadsheetColumn.headerAlign??"center",attach:i.spreadsheetColumn.attach,width:i.spreadsheetColumn.width,minWidth:i.spreadsheetColumn.minWidth,maxWidth:i.spreadsheetColumn.maxWidth,backgroundColor:i.spreadsheetColumn.backgroundColor,removePadding:i.spreadsheetColumn.removePadding,noTopBorder:t.noBorder,noBorder:t.noBorder,...r(i,"header"),children:[i.render("Header"),i.isSorted?jsxs("span",{...r(i,"header-sort-arrow"),children:[jsx("span",{children:" "}),jsx(e$1,{name:i.isSortedDesc?"VMSWeb-arrow-down":"VMSWeb-arrow-up"})]}):""]}))}))})}var Uf=Ee.thead`
  position: relative;
  z-index: 1;
`;var R1=forwardRef(tg);function tg(e,t){let o=typeof e.data=="function",r=u(),[n,i]=useState(false),a=useRef(null),s=useRef(null);useImperativeHandle(t,()=>({deselectAll:()=>{g.toggleAllRowsSelected(false);}}));let m=useCallback(b=>typeof b=="function"?{data:[],pagination:{pageCount:-1,totalItemsCount:-1}}:{data:b,pagination:{pageCount:-1,totalItemsCount:b.length}},[]),d=useMemo(()=>m(e.data),[m,e.data]),[p,f]=ee__default.useState(()=>d),c=useMemo(()=>o?p:d,[d,o,p]),h=ee__default.useMemo(()=>e.columns.map(b=>{let y={Header:b.header,accessor:b.render,id:"key"in b?b.key:undefined,spreadsheetColumn:b,disableSortBy:!b.sortable,...b.sortType&&{sortType:b.sortType}};return b.expandable&&(y.id="expander",y.Cell=da),y}),[e.columns]),g=useTable({data:c.data,columns:h,manualPagination:o,manualSortBy:o,pageCount:c.pagination.pageCount,disableSortBy:e.disableSortBy,initialState:{...e.sorted&&{sortBy:e.sorted},...e.initialPageSize&&{pageSize:e.initialPageSize}},autoResetExpanded:e.autoResetExpanded||false},useSortBy,useExpanded,usePagination,useRowSelect),S=e.noPagination?g.rows:g.page;return ee__default.useEffect(()=>{e.onChange?.(g.state),typeof e.data=="function"&&e.data(g.state).then(b=>{f(b);});},[g.state.pageIndex,g.state.pageSize,g.state.sortBy,e.onChange]),ee__default.useEffect(()=>{let b=s.current;b&&i(b.clientWidth<b.scrollWidth);},[r]),ee__default.useEffect(()=>{e.onSortedChange?.(g.state.sortBy);},[e.onSortedChange,g.state.sortBy]),jsxs(rg,{width:e.width,height:e.height,maxHeight:e.maxHeight,ref:a,children:[e.filterPanel,jsxs(ng,{isVerticalScrollBlocked:e.isVerticalScrollBlocked,children:[jsx(ig,{...g.getTableProps(),ref:s,children:jsxs(na,{children:[jsx(pa,{headerGroups:g.headerGroups,noBoxShadow:!n,hideTopCorners:!!e.filterPanel||e.noBorder,noBorder:e.noBorder,pin:e.pin}),!e.placeholder&&jsx(ia,{...g.getTableBodyProps(),children:S.map((b,y,P)=>{g.prepareRow(b);let C=y===P.length-1,T=e.renderPreComponent&&e.renderPreComponent({row:b,index:y,rows:S,containerWidth:`${a?.current?.clientWidth}px`}),w=e.renderPostComponent&&e.renderPostComponent({row:b,index:y,rows:S,containerWidth:`${a?.current?.clientWidth}px`});return jsxs(ee__default.Fragment,{children:[T&&jsx("tr",{children:jsx("td",{width:"100%",colSpan:100,children:T})}),jsx(sa,{...b.getRowProps(),isSelected:b.isSelected,hoverOnRows:e.hoverOnRows,onClick:()=>{e.onRowClick&&(g.toggleAllRowsSelected(false),g.toggleRowSelected(b.id,true),e.onRowClick(b.original));},children:b.cells.map((M,_)=>{let k=M.column.spreadsheetColumn;return jsx(Ut,{...M.getCellProps(),isNested:b.depth>0,isInLastRow:e.noPagination&&C,removeRightPadding:b.canExpand,shouldAddNestingPadding:b.depth>0&&_===0,noBorderBottom:!e.noPagination&&C,noBoxShadow:!n,attach:k.attach,width:k.width,minWidth:k.minWidth,maxWidth:k.maxWidth,justifyContent:k.cellAlign??"start",textAlign:k.cellAlign??"start",noBorder:e.noBorder,alignItems:k.alignItems,backgroundColor:k.backgroundColor,removePadding:k.removePadding,children:M.render("Cell")})})}),w&&jsx("tr",{children:jsx("td",{width:"100%",colSpan:100,children:w})})]},b.id)})}),!e.noPagination&&jsx("tfoot",{children:jsx("tr",{children:jsx(ag,{colSpan:h.length,children:jsx(ca,{table:g,totalItemsCount:c.pagination.totalItemsCount,noBorder:e.noBorder})})})})]})}),jsx(og,{children:e.placeholder})]})]})}var og=Ee.div`
  position: sticky;
  left: 0;
  width: 100%;
`,rg=Ee.div`
  ${e=>e.width&&css`
      width: ${typeof e.width=="string"?e.width:`${e.width}px`};
    `}

  ${e=>e.height&&css`
      height: ${typeof e.height=="string"?e.height:`${e.height}px`};
    `}

  ${e=>e.maxHeight&&css`
      max-height: ${typeof e.maxHeight=="string"?e.maxHeight:`${e.maxHeight}px`};
    `}
`,ng=Ee.div`
  width: 100%;
  height: 100%;
  max-height: inherit;
  overflow-y: ${e=>e.isVerticalScrollBlocked?"hidden":"auto"};
`,ig=Ee.div`
  width: 100%;
  height: 100%;
  display: flex;
`,ag=Ee.td`
  position: sticky;
  bottom: 0;
  padding: 0;
`;function L1({primary:e$1,secondary:t,...o}){return jsxs(lg,{...o,twoLineEllipsis:t===undefined,children:[jsx(e,{children:e$1}),jsx("br",{}),jsx(e,{color:"secondaryFont",children:t})]})}var ha=(e,t)=>e==="number"||typeof t=="number"?(e||0)>(t||0)?1:-1:(e||"").toLowerCase()>(t||"").toLowerCase()?1:-1,W1=(e,t,o)=>{let r=e.values[o]?.props,n=t.values[o]?.props,i=r.primary,a=n.primary;return i!==a?ha(i,a):ha(r.secondary,n.secondary)},lg=Ee.div`
  box-sizing: content-box;
  min-height: 36px;

  ${e=>e.twoLineEllipsis?h:f$1}
`;function A1({title:e$1,description:t,image:o,alt:r,pt:n="xl",pb:i="xl"}){return jsxs(mg,{width:"100%",pt:n,pb:i,alignItems:"center",children:[o&&jsx(a,{mb:"l",children:jsx("img",{src:o,alt:r})}),e$1&&jsx(a,{children:jsx(e,{fontWeight:"bold",fontSize:"l",children:e$1})}),t&&jsx(a,{mt:"s",children:jsx(e,{color:"secondaryFont",children:t})})]})}var mg=Ee(n$1)`
  background: ${e=>e.theme.colors.primaryBackground};
  border: ${e=>`1px solid ${e.theme.colors.borders}`};
  border-top: none;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
`;function U1({children:e,...t}){return jsx(gg,{width:"100%",p:"m",spacing:"m",flexWrap:"wrap",...t,children:e})}var gg=Ee(v)`
  background: ${e=>e.theme.colors.primaryBackground};
  border: 1px solid ${e=>e.theme.colors.borders};
  border-bottom: 0;
  border-top-left-radius: ${e=>e.theme.table.borderRadius};
  border-top-right-radius: ${e=>e.theme.table.borderRadius};
`;function Q1({children:e$1,width:t}){return jsx(ug,{children:jsx(xg,{width:t,pt:"s",pb:"s",pl:"m",pr:"m",children:jsx(e,{textTransform:"uppercase",color:"secondaryFont",fontSize:"s",children:e$1})})})}var ug=Ee.div`
  background-color: ${e=>e.theme.colors.dividerLines};
  width: 100%;
`,xg=Ee(a)`
  background-color: ${e=>e.theme.colors.dividerLines};
  box-sizing: border-box;
  max-width: ${e=>e.width};
  min-width: ${e=>e.width};
  border: ${e=>`1px solid ${e.theme.colors.borders}`};
  border-top: none;
  position: sticky;
  left: 0;
`;function mI(e){return jsx(yg,{...e,selectedTabClassName:"selected",selectedTabPanelClassName:"selected"})}var yg=Ee(he.Tabs)`
  font-family: ${e=>e.theme.fonts.primary};
  font-size: ${e=>e.theme.fontSizes.m};
  line-height: ${e=>e.theme.lineHeights.s};
`,Te=Ee(he.Tab)`
  position: relative;
  padding: 11px 0;
  font-family: ${e=>e.theme.fonts.primary};
  font-size: ${e=>e.theme.fontSizes.m};
  line-height: ${e=>e.theme.lineHeights.s};
  user-select: none;
  cursor: default;
  list-style: none;

  &.selected {
    font-weight: 700;
    &::after {
      content: ' ';
    }
  }

  &:focus {
    outline: none;
  }

  &::before {
    content: ' ';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
  }

  &::after {
    display: block;
    position: absolute;
    height: 2px;
    bottom: 0;
    left: 0;
    right: 0;
    transform: translateY(2px);
    background: ${e=>e.theme.colors.primaryFont};
  }

  &::marker {
    display: none;
  }
`;Te.tabsRole="Tab";var Sg=Ee(he.TabList)`
  width: max-content;
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
  border-bottom: 2px solid ${e=>e.theme.colors.borders};

  ${e=>css`
    ${Te} + ${Te} {
      margin-left: ${e.theme.spacing.l};
    }

    ${Te}:first-child {
      &::before {
        margin-right: -${e.theme.spacing.m};
      }
    }

    ${Te}:last-child {
      &::before {
        margin-left: -${e.theme.spacing.m};
      }
    }

    ${Te} + ${Te}:not(:last-child) {
      &::before {
        margin: 0 -${e.theme.spacing.m};
      }
    }
  `}
`;Sg.tabsRole="TabList";var Cg=Ee(he.TabPanel)`
  display: none;

  &.selected {
    display: block;
  }
`;Cg.tabsRole="TabPanel";function xa({options:e,value:t,onChange:o,disabled:r,backgroundColor:n="primaryBackground",...i}){let a=g(n,"lightFont","darkFont")==="lightFont",s=p$1("s"),m=p$1("xs"),d=useMemo(()=>{if(!s)return;let f=e.find(c=>c.id===t);if(f)return kg(f.id)},[s,e,t]),p="desktop";return m?p="tiny":s&&(p="mobile"),jsx(Rg,{backgroundColor:n,disabled:r,isLightTheme:a,languagePickerWidth:p,children:jsx(De,{options:e,onChange:o,value:t,displayValue:d,searchable:false,hideFilterIcon:m,disabled:r,withNativeSupport:true,filterIcon:jsx(e$1,{name:"GX-language","data-test":"language-picker-icon"}),"data-test":"language-picker",...i})})}var kg=e=>{switch(e){case "zh_CN":return "\u7B80\u4F53";case "zh_HK":return "\u7E41\u9AD4";case "ja":return "\u65E5\u672C\u8A9E";case "th":return "\u0E44\u0E17\u0E22";default:return e.toUpperCase()}},Rg=Ee(a)`
  width: ${e=>e.theme.topNav.languagePickerWidth[e.languagePickerWidth]};
  ${ea$1} {
    --border-color: ${e=>e.theme.colors.secondaryFont};
    background: ${e=>e.theme.colors[e.backgroundColor]};
  }
  ${e=>e.isLightTheme&&css`
      ${ea$1} {
        border-color: ${e.disabled?e.theme.colors.inactive:e.theme.colors.lightFont};
      }

      ${$} {
        color: ${e.disabled?e.theme.colors.inactive:e.theme.colors.lightFont};
      }

      ${f$2} {
        color: ${e.disabled?e.theme.colors.inactive:e.theme.colors.lightFont};
      }
    `}

  @media (max-width: ${e=>e.theme.breakpoints.s}px) {
    ${Po} {
      padding: ${e=>`${e.theme.spacing.sm} ${e.theme.spacing.s} ${e.theme.spacing.sm} ${e.theme.spacing.s}`};
    }
    ${$}, ${aa} {
      padding: 11px 0 11px 44px;
    }
    ${ca$1} {
      > i {
        margin: 0 14px;
      }
    }
  }

  @media (max-width: ${e=>e.theme.breakpoints.xs}px) {
    ${$}, ${aa} {
      padding: 11px 0 11px 16px;
    }
  }
`;var Eg=e=>/.+?-app\.qa\.sevenrooms\.com/g.test(e)?"https://staging-app.qa.sevenrooms.com":e.includes("eu.")?"https://www.sevenrooms.com":`https://${e}`,ba=Eg(window.location.host),Fg=`${ba}/app/global-client`;function ya({onLogin:e,onUpdate:t,onDelete:o,onCreate:r,onClose:n,onLoad:i,onLogout:a,src:s,width:m}){let d=useRef(null),p=m!=="100%",f=useCallback(c=>{let h=readIFrameMessage(c,ba);if(h)switch(h.topic){case "create":r(rr(h.data.userInfo));break;case "error":break;case "login":e(rr(h.data.userInfo));break;case "logout":a();break;case "update":t(rr(h.data.userInfo));break;case "delete":o();break;case "resize":if(!d.current)break;p&&(d.current.width=h.data.width),d.current.height=h.data.height;break;case "close":n();break;case "open":i();break;}},[r,e,a,t,o,p,n,i]);return useEffect(()=>(window.addEventListener("message",f),()=>{window.removeEventListener("message",f);}),[f]),jsx(Dg,{title:"sevenrooms-login",src:`${Fg}${s}`,height:"245px",width:m,ref:d})}var rr=({id:e,emailAddress:t,firstName:o,lastName:r,phoneNumber:n,profilePictureUrl:i,significantDates:a,preferences:s})=>{let{phoneCountryCode:m,phoneDialCode:d}=Hg(n);return {clientId:e,firstName:o,lastName:r,emailAddress:t,phoneNumber:n,phoneDialCode:d,phoneCountryCode:m,profilePictureUrl:i,significantDates:a,preferences:s}},Hg=e=>{let t=parsePhoneNumber(e,{extract:true});return {phoneCountryCode:Ng(t?.country),phoneDialCode:t?.countryCallingCode}},Ng=e=>e?.toLowerCase(),Dg=Ee.iframe`
  max-width: 100%;
  max-height: 100%;
  border: 0;
`;function Ca({active:e,setIsActive:t,closeable:o,children:r}){let n=useNavigation(),i=useSurfaceScope(),a=Ai(),s=ee.useMemo(()=>Math.random().toString(),[]),m=ee.useCallback(()=>{o&&i?.destination.parent&&n.push(i.destination.parent,{from:i.destination}),t?.(false);},[n,o,t,i?.destination]),[d,p]=ee.useState(null),f=ee.useMemo(()=>({key:s,setNode:p,close:m}),[m,s]),c=e??n.matchParams(i?.destination)!==undefined;return ee.useLayoutEffect(()=>(c&&a.register(f),()=>{a.unregister(f);}),[c]),d&&Di.createPortal(r,d)}function Pa({firstName:e,lastName:t,image:o,onClick:r,isOpen:n,"data-test":i}){return jsx(Fragment,{children:jsx(IconButton,{"data-test":i,sx:{padding:"3px","&:hover":{backgroundColor:"transparent"}},size:"small",onClick:r,"aria-controls":n?"user-profile":undefined,"aria-haspopup":"true","aria-expanded":n?"true":undefined,children:jsx(Avatar,{sx:{width:36,height:36,backgroundColor:"#DEDBD3",color:"#292928",fontSize:"1rem",fontWeight:600},src:o,children:`${e[0]}${t[0]}`.toUpperCase()})})})}function Ta({backgroundColor:e="venueColor",onLogin:t,onUpdate:o,onLogout:r,onDelete:n,isLoading:i,userFirstName:a,userLastName:s,userImage:m,disabled:d,fullWidth:p,size:f}){let c=p$1("s"),[h,g$1]=useState(false),[S,b]=useState(false),y=useMemo(()=>{let F=new URLSearchParams;return a&&F.append("firstName",a),s&&F.append("lastName",s),m&&F.append("profilePictureUrl",m),F},[a,m,s]),P=useMemo(()=>y.size?`/profile?${y.toString()}`:"",[y]),C=useMemo(()=>P===""||c,[c,P]),T=useMemo(()=>C?"530px":c?"100%":"fit-content",[c,C]),w$1=useCallback(F=>{g$1(false),t?.(F);},[t]),M=useCallback(F=>{g$1(false),o?.(F);},[o]),_=useCallback(()=>{g$1(false);},[]),k$1=useCallback(()=>{b(true);},[]),U=g(e,"lightFont","secondaryFont"),ue=`rgba(${U==="lightFont"?"255, 255, 255":"0, 0, 0"}, 0.4)`,we=useMemo(()=>jsx(ya,{onLogin:w$1,onLogout:r,onUpdate:M,onDelete:n,onCreate:w$1,onClose:_,onLoad:k$1,src:P,width:T}),[_,n,k$1,w$1,r,M,P,T]),Ye=useMemo(()=>jsx(k,{alignSelf:"center",height:"100%",justifyContent:"flex-end",width:p?"100%":"auto",children:jsx(qg,{onUpdate:o,backgroundColor:e,fontAndBorderColor:U,outlineColor:ue,isModalOpen:h,setIsModalOpen:g$1,isLoading:i,userFirstName:a,userLastName:s,userImage:m,disabled:d,fullWidth:p,size:f})}),[e,d,U,p,i,h,o,ue,f,a,m,s]);return C?jsxs(Fragment,{children:[Ye,jsx(Ca,{active:h,setIsActive:g$1,children:jsxs(Bt,{ariaLabel:"login-modal",width:"fit-content",maxWidth:"100%",children:[!S&&jsx(It,{onClose:_}),jsx(Wn,{overflow:"visible",width:"100%",pr:"none",pl:"none",pt:"sm",pb:"lm",children:we})]})})]}):jsx(w,{show:h,alignment:c?"bottom":"bottomRight",shouldCloseOnBodyClick:true,targetOffset:0,bodyOffset:0,onClose:()=>g$1(false),content:jsx(k,{borderRadius:"m",boxShadow:"tertiary",overflow:"hidden",pb:"l",backgroundColor:"primaryBackground",children:we}),children:Ye})}function qg({isLoading:e,userFirstName:t,userLastName:o,userImage:r,isModalOpen:n,setIsModalOpen:i,backgroundColor:a,fontAndBorderColor:s,outlineColor:m,disabled:d,fullWidth:p,size:f}){let{formatMessage:c}=useLocales(),h=useCallback(()=>{i(!n);},[n,i]);return e?jsx(SevenRoomsProgress,{"aria-label":"In Progress"}):t&&o?jsx(Pa,{firstName:t,lastName:o,image:r,onClick:h,isOpen:n,"data-test":"sr_avatar"}):jsxs(Jg,{"data-test":"sr-login-button",backgroundColor:a,fontAndBorderColor:s,outlineColor:m,borderRadius:"s",onClick:h,disabled:d,fullWidth:p,size:f,children:[jsx(SevenRoomsIcon,{sx:{marginRight:"8px"}}),c(gflMessages.resWidgetLogInButton)]})}var Qg="100px",Jg=Ee(G)`
  width: ${e=>e.fullWidth?"100%":Qg};
  background-color: ${e=>e.theme.colors[e.backgroundColor]};
  color: ${e=>e.theme.colors[e.fontAndBorderColor]} !important;
  border-color: ${e=>e.theme.colors[e.fontAndBorderColor]};
  border-radius: ${e=>e.theme.borderRadius.s};

  &:focus:not(:focus-visible) {
    ${e=>`outline: ${e.theme.borderWidth.l} solid ${e.outlineColor};`}
    color: ${e=>e.theme.colors[e.fontAndBorderColor]} !important;
    border-color: ${e=>e.theme.colors[e.fontAndBorderColor]};
    background-color: ${e=>e.theme.colors[e.backgroundColor]};
  }

  &:focus,
  &:hover {
    color: ${e=>e.theme.colors[e.fontAndBorderColor]} !important;
    border-color: ${e=>e.theme.colors[e.fontAndBorderColor]};
    background-color: ${e=>e.theme.colors[e.backgroundColor]};
  }

  &:focus {
    ${e=>`outline: ${e.theme.borderWidth.l} solid ${e.outlineColor};`}
    outline-offset: ${e=>e.theme.borderWidth.m};
  }

  &:focus-visible {
    ${e=>`outline: ${e.theme.borderWidth.l} solid ${e.outlineColor};`}
    outline-offset: ${e=>e.theme.borderWidth.m};
    color: ${e=>e.theme.colors[e.fontAndBorderColor]} !important;
    background-color: ${e=>e.theme.colors[e.backgroundColor]};
    border-color: ${e=>e.theme.colors[e.fontAndBorderColor]};
  }

  &:hover {
    font: ${e=>e.theme.textStyles.body1Bold};
    ${e=>`border: ${e.theme.borderWidth.l} solid ${e.theme.colors[e.fontAndBorderColor]};`}
  }
`;function hM({baseUrl:e,logo:t,logoLabel:o,languagePicker:r,grow:n=false,sevenRoomsLogin:i}){let a$1=p$1("m"),s=p$1("s"),m=p$1("xs"),{topNav:d,colors:{venueColor:p,primaryBackground:f}}=useTheme(),c=a$1?"m":"lm",h="desktop";return m?h="tiny":s&&(h="mobile"),jsxs(n$1,{"data-test":"top-nav",width:"100%",backgroundColor:"venueColor",borderBottomColor:p.toLocaleLowerCase()===f.toLocaleLowerCase()?"borders":"venueColor",justifyContent:r?"space-between":"center",zIndex:"default",position:"sticky",top:"none",children:[jsxs(v,{p:`sm ${c}`,height:a$1?d.height.mobile:d.height.desktop,justifyContent:"space-between",alignItems:"flex-start",children:[jsx(a,{width:"33%",minWidth:d.languagePickerWidth[h],children:r&&jsx(xa,{...r,backgroundColor:"venueColor"})}),jsx(th,{baseUrl:e,logoLabel:o,logo:t}),jsx(a,{width:"33%",children:i&&jsx(Ta,{...i})})]}),n&&jsx(a,{width:"100%",height:`${d.spacerHeight}px`})]})}function th({logo:e$1,baseUrl:t,logoLabel:o}){let r=g("venueColor","lightFont","darkFont");return e$1?jsx($n,{"data-test":"logo-image",baseUrl:t,logo:e$1,logoLabel:o,height:"100%"}):jsx(n$1,{alignItems:"center",justifyContent:"center",height:"100%",children:jsx(e,{textStyle:"h1",fontSize:"xxl",color:r,children:o.toUpperCase()})})}

export { Wn as $, pB as $a, cn as A, ni as Aa, ya as Ab, so as B, si as Ba, Ca as Bb, Xs as C, Ri as Ca, Ta as Cb, Ex as D, $i as Da, hM as Db, Xx as E, Ik as Ea, ob as F, Vk as Fa, ol as G, Zk as Ga, kt as H, o0 as Ha, rl as I, d0 as Ia, un as J, y0 as Ja, $b as K, zi as Ka, Mb as L, Sp as La, fl as M, Ai as Ma, Eb as N, Y0 as Na, Nb as O, oR as Oa, Ab as P, Vi as Pa, ry as Q, At as Qa, Cl as R, FR as Ra, Pl as S, Yi as Sa, vl as T, zR as Ta, wn as U, GR as Ua, hy as V, n$ as Va, Rn as W, m$ as Wa, $n as X, u$ as Xa, Bt as Y, P$ as Ya, Mn as Z, H$ as Za, Ul as _, G$ as _a, fw as a, En as aa, PB as ab, Ne as b, Jl as ba, na as bb, pP as c, Hn as ca, ia as cb, Jd as d, It as da, Ut as db, Xn as e, Nn as ea, zB as eb, v as f, ot as fa, _B as fb, Pi as g, ES as ga, sa as gb, Sm as h, jS as ha, ca as hb, Ar as i, Dn as ia, Nf as ib, Gr as j, gC as ja, Df as jb, Ph as k, TC as ka, zf as kb, Kr as l, On as la, R1 as lb, Yr as m, UC as ma, tg as mb, qr as n, Gn as na, ag as nb, tu as o, Zd as oa, L1 as ob, fu as p, Lt as pa, W1 as pb, wu as q, ac as qa, lg as qb, Jr as r, Po as ra, A1 as rb, hs as s, De as sa, U1 as sb, jr as t, NP as ta, Q1 as tb, ys as u, AP as ua, mI as ub, me as v, hv as va, Te as vb, nn as w, Pc as wa, Sg as wb, rx as x, Rc as xa, Cg as xb, je as y, Iv as ya, xa as yb, dn as z, ti as za, Eg as zb };
